import React, {memo, MutableRefObject, useCallback, useEffect, useMemo, useState} from 'react';
import "./index2.scss";
import {
    Autocomplete, Avatar, Box,
    Checkbox,
    Chip, Collapse,
    CircularProgress,
    Dialog,
    IconButton,
    MenuItem, TableContainer,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';
import {Theme, useTheme} from '@mui/material/styles';

import Swal from 'sweetalert2';
import InsertCommentIcon from '@mui/icons-material/InsertComment';

// types
import {Filter, HeadCell} from 'types';


// project imports
import ActionCell from './custom-cells/ActionCell';

// assets
import Product from '../../../types/product';
import {clearCopiedForcedDetails, createOrderDataEasy, getSumProducts, hasTempOrderDriver, OrderData, orderKey, orderKeyRef, writeOrdersToOD} from '../../../types/OrderData';
import {useDispatch, useSelector} from 'react-redux';
import {OrderActiveState} from '../../../types/OrderActiveState';

import AddCustomer from '../../customer/AddCustomer';
import {CalendarMonth, Email, Person, WhatsApp} from '@mui/icons-material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import JSDB from '../../../fromKotlin/nk';
import {IconInfoCircle, IconPhone} from "@tabler/icons";
import {getCustomers, selectCustomersObjs} from "../../../store/customers/customersSlice";
import {Bucket, DeviceFloppy, FileCheck, MapPin, Package, Tag} from "tabler-icons-react";
import AgTable, {ITableControls} from "../../../ui-component/ag-grid/Ag-Table";
import {cloneDeep} from "lodash";
import contextMenu2 from './contextMenu2';
import LockIcon from "@mui/icons-material/Lock";
import PushPinIcon from "@mui/icons-material/PushPin";
import LocationCityIcon from '@mui/icons-material/LocationCity';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import RouteIcon from '@mui/icons-material/Route';
import {
    autoSizeAllColumns,
    customGroup,
    customGroupLabelForChip,
    rowGroupRenderer
} from 'ui-component/ag-grid/ag-table-utils';
import {addDragToTable, removeDragFromTable} from 'ui-component/ag-grid/ag-grid-functions';
import {groupByUnStr} from "../../../api/customer/analytics.api";
import FormDialog from "../../orders/datasheet/custom-components/distributeDialog";
import {columns} from "../../../store/kanban";
import {dateObjectToString, roundDecimals} from "../../../fromKotlin/nkutils";
import LimitedActionCell from './custom-cells/LimitedActionCell';

import SendMessageDialog from "../../../ui-component/dialogs/sendMessage";
import ChipRangeDate from "./ChipRangeDate";
import ReorderDialog, {ReorderDialogOrders} from "../../../ui-component/ag-grid/components/reorder-dialog";
import ChooseDateMultiAction from "../../../ui-component/dialogs/chooseDateMultiAction";
import {putInventoryNextDay, useOpenOrders, useOpenOrders2} from "../../../hooks/customer/documents.hooks";
import ProductsToExportDialog from 'ui-component/dialogs/productsToExportDialog';
import {
    buildClientCartesetDebt,
    buildNotesSum,
    docResultsDeserialize,
    getMassDocumentPdf, sendPdfEmail
} from "../../../api/customer/documents.api";
import {callbackNetworkResult, getFile} from "../../../api/customer/files.api";
import {
    collectRowExternalSoftwareDocs,
    getRowExternalSoftwareSentStatus,
    hasExternalSoftwareIntegration,
    mergeRefreshedDocsIntoRow,
    sendAndRefreshDocsToExternalSoftware
} from "../../../utils/externalSoftware";
import {updateMassCustomerProduct} from 'store/customersProducts/customersProductsSlice';
import BaseOrDataSelector from './custom-components/BaseOrDataSelector';
import DocumentPreview from "../../customer/profile/documents/DocumentPreview";
import DocumentNew from "../../customer/profile/documents/DocumentNew";
import MyChip from "../../../ui-component/extended/Chip";
import {closedOrderWithDeliveryWarning, deserializeDocument, isClosedOrderWithDeliveryNote, isNoteCompare, TYPED_FIRST_UNIT_MESSAGE} from "../../../types/DocumentsTypes/utils";
import {notesArePrinted} from "../../../types/DocumentsTypes/Document";
import DocumentsTable from "../../customer/profile/documents/Table";
import GenerativeLoader from "../../../ui-component/GenerativeLoader";
import FunctionsIcon from "@mui/icons-material/Functions";
import {pdf} from "../../../assets/images";
import {FormattedMessage} from "react-intl";
import PrintIcon from "@mui/icons-material/PrintTwoTone";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import ArticleIcon from '@mui/icons-material/Article';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import {format} from "date-fns";
import config from "../../../config";
import {enUS, he} from "date-fns/locale";
import {
    useTextToDataAiAvailability,
} from '../../../features/text-to-data-ai';
import { aiOpenDocsManager } from '../../../hooks/useAiAssistant';
import { useAiAssistantAvailability } from '../../../hooks/useAiAssistentInfo';
import DriverLinkDialog from './driver-link/DriverLinkDialog';
import PersistentDriverLinkDialog from './driver-link/PersistentDriverLinkDialog';
// <div style={{
//     display: 'flex',
//     justifyContent: 'center',
//
//     alignItems: 'center',
//
//     flexWrap: 'wrap'
//
// }}>
//
//     {openDrawer ? <AddCustomer
//         open={openDrawer}
//         handleDrawerOpen={handleDrawerClose}
//         id={rowData.id}
//         editable={true}
//     /> : undefined}
//
//     <Tooltip title='חולק היום'>
//         <Checkbox disabled checked={rowData.readonly}
//                   style={{ 'color': 'green', paddingInline: 0 }} size='small' />
//     </Tooltip>
//     <Tooltip title='הוזמן היום'>
//         <Checkbox disabled checked={rowData.orderId !== ''}
//                   style={{ 'color': 'red', paddingInline: 2 }} size='small' />
//     </Tooltip>
//     <IconButton
//         style={{ color: rowData.notes && rowData.notes != '' ? 'orange':undefined }} size='medium' onClick={(e) => {
//
//
//         Swal.fire({
//             title: 'הערות',
//             input: !rowData.readonly ? 'textarea':undefined,
//             inputValue:rowData.notes ?? "",
//             inputAttributes: {
//
//                 'aria-label': rowData.notes ?? ""
//             },
//             showCancelButton: true,
//             showConfirmButton: !rowData.readonly,
//             text: rowData.readonly ? rowData.notes:undefined,
//             showClass: {
//                 popup: 'animate__animated animate__fadeInDown'
//             },
//             hideClass: {
//                 popup: 'animate__animated animate__fadeOutUp'
//             }
//             , confirmButtonText: 'צור הערה'
//             , cancelButtonText: 'סגור'
//         }) .then((result) => {
//             /* Read more about handling dismissals below */
//
//             if(result.isConfirmed && !rowData.readonly) {
//                 updatedRowIds.add(rowData.id)
//                 setData((prev) =>
//                     prev.map((d, i) =>
//                         d.id! == rowData.id
//                             ? {...d,  notes:String(result.value),me:d} : d
//                     )
//                 );
//
//             }
//         });
//     }}>


export const DataSheetGridContext = React.createContext({
    activeRow: 0,
    openDrawer: false,
    setOpenDrawer: (open: boolean) => {
    },
    handleOpenDrawer: () => {
    },
    setSingleSave: (rowid) => {

    },
    setSingleDelete: (rowid) => {

    },
    callPrevOrder: (callDate: Date, ids?: number[], day?: number) => {

    },
    setDrawerSingleData: (data: any) => {
    },
    date: new Date(),
    unsavedRowsLength: 0,
    current: null,
    markedIds: new Set(),
    updatedRowIds: null,
    updatedDriverRowIds: null,
    data: null,
    setData: null,
    columns: null,
    disableKeyBoard: null,
    saveOrder: null,
    onOpenSyncConflict: (_row: any) => undefined,
    callPrevDaily: null,
    deleteOrder: null,
    dvs_flag: false,
    activeState: null,
    onApplyFilter: null,
    addCustomerFilter: null,
    removeAllFilters: null,
    setAll: null,
    setActiveRow: null,
});

interface MainStyleProps {
    theme: Theme;
    open: boolean;
}


export const simulateClick = (className) => {
    const clickEvent = document.createEvent('MouseEvents');
    clickEvent.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0,
        false, false, false, false, 0, null);

    const element = document.getElementsByClassName(className).item(0);
    element?.dispatchEvent(clickEvent);
};

const ErpSentChip = ({row, gridApi, setTempData, value}: {
    row: any;
    gridApi?: any;
    setTempData?: any;
    value: string;
}) => {
    const sending = !!row?._erpSending;
    const docs = collectRowExternalSoftwareDocs(row);
    if (!value && !sending) return null;
    return (
        <Tooltip title='לחץ לשליחה / שליחה מחדש לתוכנה חיצונית'>
            <span>
                <MyChip
                    label={sending ? <CircularProgress size={14} color='inherit' /> : value}
                    size='small'
                    variant='outlined'
                    disabled={sending}
                    chipcolor={value === 'כן נשלח' ? 'success' : 'orange'}
                    sx={{cursor: sending ? 'default' : 'pointer', minWidth: 72, justifyContent: 'center'}}
                    onClick={() => {
                        if (sending || !docs.length) return;
                        row._erpSending = true;
                        gridApi?.refreshCells?.({force: true, columns: ['erpSent']});
                        let succeeded = false;
                        callbackNetworkResult(
                            async () => {
                                const refreshed = await sendAndRefreshDocsToExternalSoftware(docs);
                                succeeded = true;
                                return refreshed;
                            },
                            (refreshed) => {
                                const merged = mergeRefreshedDocsIntoRow(row, refreshed);
                                merged._erpSending = false;
                                if (typeof setTempData === 'function') {
                                    setTempData((prev: any[]) => (prev || []).map((r) => (
                                        r && orderKey(r) === orderKey(row) ? merged : r
                                    )));
                                } else {
                                    Object.assign(row, merged);
                                }
                                gridApi?.refreshCells?.({force: true, columns: ['erpSent']});
                            },
                            (loading) => {
                                if (!loading && !succeeded) {
                                    row._erpSending = false;
                                    gridApi?.refreshCells?.({force: true, columns: ['erpSent']});
                                }
                            }
                        );
                    }}
                />
            </span>
        </Tooltip>
    );
};

/** Effective address for grid display: forced_address (כתובת מאולצת) overrides the client, like orderDriver overrides driverName. */
const getOrderRowAddressParts = (row?: Record<string, any>) => {
    const forced = (row?.forced_address ?? '').trim();
    if (forced) {
        const parts = forced.split(',');
        const hasStructuredParts = parts.length > 1;
        return {
            city: hasStructuredParts ? (parts[0]?.trim() ?? '') : forced,
            street: hasStructuredParts ? (parts[1]?.trim() ?? '') : '',
            streetNumber: hasStructuredParts ? (parts[2]?.trim() ?? '') : '',
            full: forced,
            isForced: true,
        };
    }
    if (!row?.id) {
        return {city: '', street: '', streetNumber: '', full: '', isForced: false};
    }
    const client = JSDB().getClient(Number(row.id)).first;
    const city = client?.city ?? row?.city ?? '';
    const street = client?.street ?? row?.street ?? '';
    const streetNumber = client?.streetNumber ?? row?.streetNumber ?? '';
    const address = street && streetNumber ? `${street}, ${streetNumber}` : street;
    const full = city && address ? `${city} ${address}` : (city || address);
    return {city, street, streetNumber, full, isForced: false};
};

const headCells: HeadCell[] = [
    {
        id: 'checkbox',
        numeric: false,
        label: '',
        align: 'center',
        type: 'string',
    },
    {
        id: 'actions',
        numeric: false,
        label: 'פעולות',
        align: 'center',
        filterable: false,
        sortable: false,
        pinned: "left",
        cellRenderer: ({params}) => {
            if ((params?.node?.rowPinned || params?.node?.group)) return '';
            return <ActionCell rowData={params?.data} rowIndex={params?.rowIndex} params={params}/>
        },
        minWidth: 250,
    },
    {
        id: "limited-actions",
        numeric: false,
        label: 'פעולה',
        align: 'center',
        filterable: false,
        sortable: false,
        pinned: "left",
        hide: true,
        cellRenderer: ({params}) => {
            if ((params?.node?.rowPinned || params?.node?.group)) return '';
            return <LimitedActionCell rowData={params?.data} rowIndex={params?.rowIndex} params={params}/>
        },
        minWidth: 100,
        maxWidth: 100,
    },
    {
        id: 'id',
        numeric: true,
        type: 'number',
        label: 'מזהה',
        align: 'center',
        maxWidth: 100,
        pinned: "right",
        extractFunc: (rowData) => Number(rowData.id) ?? '',
    },
    {
        id: 'customer',
        numeric: false,
        label: 'שם לקוח',
        align: 'center',
        pinned: "right",
        cellRenderer({params, setOpenCustomerDrawer, setSelectedCustomerId}) {
            if (params?.node?.group) return params?.value ?? '';
            if (params?.node?.rowPinned) return params?.value ?? '';
            if(!(params?.value) || params?.value=='') return '';
            return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    // flexWrap: 'wrap',
                    width: '100%',
                    overflow: 'hidden',
                }}>
                    <Tooltip title='פרטי לקוח' style={{color: 'blue', marginRight: 0, marginLeft: 0, paddingInline: 0}}>
                        <>
                            <IconButton
                                style={{
                                    color: 'blue',
                                    marginRight: 0,
                                    marginLeft: 0,
                                    paddingInline: 0,
                                    display: "flex",
                                    flexDirection: "column"
                                }} size='medium'
                                onClick={() => {
                                    setSelectedCustomerId(params?.data);
                                    setOpenCustomerDrawer(true);
                                }}>
                                <Person/>
                            </IconButton>
                            <span style={{
                                fontSize: "0.8rem"
                            }}>
                                {params?.value ?? ''}
                            </span>
                        </>
                    </Tooltip>
                </div>
            )
        },
    },
    {
        id: 'english_name',
        numeric: false,
        label: 'שם לקוח באנגלית',
        align: 'center',
        type: 'string',
        hide: true,
        extractFunc: (row) => {
            if (row?.id) {
                const client = JSDB().getClient(Number(row.id)).first;
                return client?.name_english ?? '';
            }
            return '';
        },
        priority: -1,
    },
    {
        id: 'last_visit',
        numeric: false,
        label: 'ביקור אחרון',
        align: 'center',
        hide: true,
        type: 'dateStr',
        filterable: true,
        priority: -1,
        extractFunc: (row) => {
            if (!row?.id) return '';
            const client = JSDB().getClient(Number(row.id))?.first;
            return client?.lastVisit ? JSDB().getDatesManipulator().dateIsrael(client.lastVisit) : '';
        },
    },
    {
        id: "customerActions",
        label: "פעולות לקוח",
        numeric: false,
        maxWidth: 120,
        aggFunc: 'count',
        minWidth: 120,
        pinned: "right",
        extractFunc: (rowData) => {
            return rowData?.dvs?.length ?? 0 > 0
        },
        cellRenderer({params, updatedRowIds, setTempData}) {
            if (params?.node?.group) return '';
            if (params?.node?.rowPinned) {
                return (
                    <div style={{
                        display: 'flex',
                        alignItems: "center",
                    }}>
                        {params?.node?.data?.customerActions ? rowGroupRenderer(params?.node?.data?.customerActions || "") : ''}
                        <FileCheck style={{
                            color: "green",
                            marginRight: "5px"
                        }}/>
                    </div>
                )
            }
            const rowData = params?.data ?? {};
            return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-evenly',
                    alignItems: 'center',
                    width: '100%',
                    overflow: 'hidden',
                    maxWidth: 120
                }}>
                    <Tooltip title='חולק היום'>
                        <Checkbox disabled checked={params?.data?.readonly}
                                  style={{'color': 'green', paddingInline: 0}} size='small'/>
                    </Tooltip>

                    <Tooltip title='הוזמן היום'>
                        <Checkbox disabled checked={params?.data?.orderId !== ''}
                                  style={{'color': 'red', paddingInline: 2}} size='small'/>
                    </Tooltip>

                    <IconButton
                        style={{color: rowData.notes && rowData.notes != '' ? 'orange' : undefined}} size='medium'
                        onClick={(e) => {


                            Swal.fire({
                                title: 'הערות',
                                input: !rowData?.readonly ? 'textarea' : undefined,
                                inputValue: rowData?.notes ?? "",
                                inputAttributes: {

                                    'aria-label': rowData?.notes ?? ""
                                },
                                showCancelButton: true,
                                showConfirmButton: !rowData?.readonly,
                                text: rowData?.readonly ? rowData?.notes : undefined,
                                showClass: {
                                    popup: 'animate__animated animate__fadeInDown'
                                },
                                hideClass: {
                                    popup: 'animate__animated animate__fadeOutUp'
                                }
                                , confirmButtonText: 'צור הערה'
                                , cancelButtonText: 'סגור'
                            }).then((result) => {
                                /* Read more about handling dismissals below */

                                if (result?.isConfirmed && !rowData?.readonly) {
                                    const targetKey = orderKey(rowData);
                                    updatedRowIds.add(targetKey)
                                    params.data.hasBeenEdited = true;
                                    params.api.refreshCells({force: true, rowNodes: [params.node]});
                                    setTempData((prev) =>
                                        prev.map((d) => {
                                            // Must match by orderKey — client id alone would overwrite
                                            // sibling orders for the same client (e.g. חולון / ראשון).
                                            if (orderKey(d) !== targetKey) return d;
                                            const newD = {...d, notes: String(result.value), hasBeenEdited: true};
                                            newD.me = newD;
                                            return newD;
                                        })
                                    );

                                }
                            });
                        }}>
                        <InsertCommentIcon/>
                    </IconButton>
                </div>
            )
        }
    },
    {
        id: 'orderId',
        numeric: true,
        label: 'מס הזמנה',
        hide: false,
        align: 'right',

        cellRenderer({params, setPreviewOpen}) {
            if (params?.node?.group || params?.node?.rowPinned) return '';
            return (<Box sx={{
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', '& .MuiButton-root': {
                    minWidth: "0px",
                }
            }}>
                <MyChip
                    sx={
                        {
                            marginTop: "8px",
                        }
                    }
                    label={params?.value}
                    onClick={() => {
                        if (params?.node?.data?.nkObject) {
                            setPreviewOpen(deserializeDocument(params?.node?.data?.nkObject));
                        }
                    }}
                    variant='outlined'
                    size='small'
                    chipcolor={params?.node?.data?.readonly ? 'success' : 'orange'}
                />
                 <Tooltip title={'פירוט תעודות'}>
                    <GenerativeLoader
                        disabled={!(params?.node?.data?.dvs && params?.node?.data?.dvs?.length>0)}
                        func={(setLoader) => {

                            setPreviewOpen(params?.node?.data?.dvs?.map((d)=>deserializeDocument(d?.nkObject)));

                        }} icon={<IconButton
                        aria-label='expand row'
                        size='small'

                    >
                        <ArticleIcon color={!(params?.node?.data?.dvs && params?.node?.data?.dvs?.length>0) ? 'action':'primary'}/>
                    </IconButton>}/>

                </Tooltip>



            </Box>)
        },

    },


    {
        id: 'date',
        numeric: false,
        label: 'תאריך',
        align: 'center',
        type: 'dateStr',
        cellEditor: 'agDateStringCellEditor',
        editable: (row) => {
            return !row?.node?.data?.readonly
        },
        sortable: true
        , filterable: true,


    },
    {
        id: 'delivery_date',
        numeric: false,
        label: 'תאריך אספקה',
        align: 'center',
        type: 'dateStr',
        cellEditor: 'agDateStringCellEditor',
        editable: (row) => !row?.node?.data?.readonly,
        sortable: true,
        filterable: true,
        hide: true,
        priority: -1,
    },
    {
        id: 'forced_business_name',
        numeric: false,
        label: 'שם עסק מאולץ',
        align: 'center',
        hide: true,
        priority: -1,
        cellEditor: 'agLargeTextCellEditor',
        cellEditorPopup: true,
        editable: (row) => !row?.node?.data?.readonly,
    },
    {
        id: 'forced_address',
        numeric: false,
        label: 'כתובת מאולצת',
        align: 'center',
        hide: true,
        priority: -1,
        cellEditor: 'agLargeTextCellEditor',
        cellEditorPopup: true,
        editable: (row) => !row?.node?.data?.readonly,
    },
    {
        id: 'collectorData',
        numeric: true,
        label: 'ליקוט',
        hide: true,
        align: 'center'
    },
    {
        id: 'karton',
        numeric: true,
        label: '~קרטונים',
        hide: true,
        align: 'center',
        aggFunc: 'sum',
        pinnedRowProps: {
            action: "sum",
        },
        cellRenderer: ({ params }) => {
            if(params?.node?.rowPinned){
                return params?.data?.karton
            }
            if (params?.node?.group) {
                return rowGroupRenderer(params?.value || "");
            }
            return params?.value || ""
        },
        priority: -1
    },
    {
        id: 'money',
        numeric: true,
        label: 'סכום',
        hide: true,
        align: 'center',
        aggFunc: 'sum',
        pinnedRowProps: {
            action: "sum",
        },
        extractFunc: (rowData) => {
            return rowData?.nkObject?.value ? roundDecimals(rowData?.nkObject?.value) : undefined

        },
        cellRenderer: ({ params }) => {
            if(params?.node?.rowPinned){
                return params?.data?.money
            }
            if (params?.node?.group) {
                return rowGroupRenderer(params?.value || "");
            }
            return params?.value || ""
        },
        priority: -1
    },    {
        id: 'moneyBefore',
        numeric: true,
        label: 'סכום לפני',
        hide: true,
        align: 'center',
        aggFunc: 'sum',
        pinnedRowProps: {
            action: "sum",
        },
        extractFunc: (rowData) => {
            return rowData?.nkObject?.value ? roundDecimals(rowData?.nkObject?.value - rowData?.nkObject?.taxPaid) : undefined

        },
        cellRenderer: ({ params }) => {
            if(params?.node?.rowPinned){
                return params?.data?.moneyBefore
            }
            if (params?.node?.group) {
                return rowGroupRenderer(params?.value || "");
            }
            return params?.value || ""
        },
        priority: -1
    },
    {
        id: "locked_products",
        numeric: true,
        label: "נעילות",
        hide: true,
        align: "center",
        aggFunc: "sum",
        pinnedRowProps: { action: "sum" },

        extractFunc: (rowData: Record<string, any>) => {
            if (!rowData || typeof rowData !== "object") return 0;

            const hasLocked = Object.keys(rowData).some((k) => {
                if (!k.startsWith("lock_")) return false;

                const v = rowData[k];
                if (v === undefined || v === null) return false;

                // treat numeric strings too
                return Number(v) > 0;
            });

            return hasLocked ? 1 : 0;
        },

        cellRenderer: ({ params }) => {
            const v = Number(params?.value ?? 0);
            if (v <= 0) return "";

            const isGroup = !!params?.node?.group;
            const isPinned = !!params?.node?.rowPinned;

            // optional: show count on grouped/pinned rows (since it's summed)
            const text = (isGroup || isPinned) ? `נעול (${v})` : "נעול";

            return (
                <Tooltip title="קיימת נעילה על למוצר">
                    <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
                        <LockIcon fontSize="small" />
                        <Typography variant="body2">{text}</Typography>
                    </Box>
                </Tooltip>
            );
        },

        priority: -1,
    },
    {
        id: 'totalProducts',
        numeric: true,
        label: 'סכום מוצרים',
        hide: true,
        align: 'center',
        aggFunc: 'sum',
        pinnedRowProps: {
            action: "sum",
        },
        cellRenderer: ({ params }) => {
            if(params?.node?.rowPinned){
                return params?.data?.totalProducts
            }
            if (params?.node?.group) {

                return rowGroupRenderer(params?.value || "");
            }
            return params?.value || ""
        },
        editable: false,
        extractFunc: (rowData) => {
            return rowData?.nkObject?.amount_pos ? roundDecimals(rowData?.nkObject?.amount_pos) : 0

        },
        priority: -1
    },
    {
        id: 'totalProductsSec',
        numeric: true,
        label: 'סכום מידת מוצרים',
        hide: true,
        align: 'center',
        aggFunc: 'sum',
        pinnedRowProps: {
            action: "sum",
        },
        cellRenderer: ({ params }) => {
            if(params?.node?.rowPinned){
                return params?.data?.totalProductsSec
            }
            if (params?.node?.group) {
                return rowGroupRenderer(params?.value || "");
            }
            return params?.value || ""
        },
        editable: false,
        extractFunc: (rowData) => {
            return rowData?.nkObject?.amount_pos_sec ? roundDecimals(rowData?.nkObject?.amount_neg_sec) : 0

        },
        priority: -1
    },
    {
        id: 'totalAmountSecond',
        numeric: true,
        label: 'מידה ארגזים',
        hide: true,
        align: 'center',
        aggFunc: 'sum',
        pinnedRowProps: {
            action: "sum",
            decimals: 3,
        },
        cellRenderer: ({ params }) => {
            const raw = params?.node?.rowPinned ? params?.data?.totalAmountSecond : params?.value;
            const n = Number(raw);
            const shown = raw === '' || raw == null || Number.isNaN(n) ? (raw ?? '') : roundDecimals(n, 3);
            if (params?.node?.group) {
                return rowGroupRenderer(shown ? String(shown) : '');
            }
            return shown ?? '';
        },
        editable: false,
        extractFunc: (rowData) => {
            try {
                return roundDecimals(rowData?.nkObject?.getAmountsSecond?.() ?? 0, 3);
            } catch {
                return 0;
            }
        },
        priority: -1
    },
    {
        id: 'status',
        numeric: false,
        label: 'סטטוס',
        align: 'center',
        editable: (row) => {
            return !row?.node?.data?.readonly
        },
        cellRenderer: ({params}) => {
            if (params?.node?.rowPinned) {
                return (
                    <div style={{
                        display: 'flex',
                        alignItems: "center",
                    }}>
                        {params?.value && params?.value != 0 ? params?.value : ''}
                    </div>
                )
            }
            return params?.value ?? ""; //<CustomerStatus customer={params?.data} />
        },
        enableRowGroup: true
    },
    {
        id: 'category',
        numeric: false,
        type: "string",
        type:'numOrStr',
        label: 'קטגוריה',
        align: 'center',
        pinnedRowProps: {
            action: "uniqueCount"
        },
        editable: (row) => {
            return !row?.node?.data?.readonly
        },
        enableRowGroup: true
    },
    {
        id: "location",
        label: "GPS",
        hide: true,
        numeric: false,
        priority: -1,
        cellRenderer: ({params}) => {
            if ((params?.node?.rowPinned || params?.node?.group)) return '';
            return (
                <div style={{
                    display: 'flex',
                    alignItems: "center",
                }}
                >
                    {params?.value != "" && <><MapPin size={14} strokeWidth={1} color="#000000"/>
                        <div><Typography variant="caption">{params?.value}</Typography></div>
                    </>}
                </div>
            )
        },
        extractFunc: (row) => {
            if (row.id) {
                const client = JSDB().getClient(Number(row.id)).first;
                return client?.location ?? '';
            }
            return ''

        },
    },
    {
        id: "last_created",
        label: "תאריך יצירה",
        numeric: false,
        hide: true,
        priority: -1,
       type: "date", align: 'center', filterable: false,
        dataFormat: "dateWithTime",
        cellRenderer: ({params}) => {
            if (params?.node?.group) return params.value || '';
            return (params?.data?.last_created ?
                    <span>{format(params?.data?.last_created, 'PPP HH:mm', {locale: config.i18n === 'he' ? he : enUS})}</span> : <></>
            );
        },
    },
    {
        id: "last_updated",
        label: "תאריך עדכון",
        numeric: false,
        hide: true,
        priority: -1,
        type: "date", align: 'center', filterable: false,
        dataFormat: "dateWithTime",
        cellRenderer: ({params}) => {
            if (params?.node?.group) return params.value || '';
            return (params?.data?.last_updated ?
                    <span>{format(params?.data?.last_updated, 'PPP HH:mm', {locale: config.i18n === 'he' ? he : enUS})}</span> : <></>
            );
        },
    },
    {
        id: "notes",
        label: "הערות",
        numeric: false,
        hide: true,
        priority: -1,
        cellEditor: 'agLargeTextCellEditor',
        cellEditorPopup: true,
        editable: (row) => {
            return true
        },
    },


    {
        id: "perment_notes",
        label: "הערות קבועות",
        numeric: false,
        hide: true,
        priority: -1,
        extractFunc: (row) => {
            if (row.id) {
                const client = JSDB().getClient(Number(row.id)).first;
                return client?.comments ?? '';

            } else
                return ''

        },
    },
    {
        id: "phone",
        label: "טלפון",
        numeric: false,
        hide: true,
        priority: -1,
        cellRenderer: ({params}) => {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
                >
                    {params?.value && <Typography variant="subtitle1">
                        <IconPhone size={12} strokeWidth={1} color='#000000'/> {params?.value}
                    </Typography>}
                </div>
            )
        },
        extractFunc: (row) => {
            if (row.id) {
                const client = JSDB().getClient(Number(row.id)).first;
                return client?.getPhone() ?? '';
            } else
                return ''
        },
    },
    {
        id: "phone2",
        label: "טלפון 2",
        numeric: false,
        priority: -1,
        hide: true,
        cellRenderer: ({params}) => {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
                >
                    {params?.value && <Typography variant="subtitle1">
                        <IconPhone size={12} strokeWidth={1} color='#000000'/> {params?.value}
                    </Typography>}
                </div>
            )
        },
        extractFunc: (row) => {
            if (row.id) {
                const client = JSDB().getClient(Number(row.id)).first;
                return client?.getSecondPhone() ?? '';
            }
            return ''

        },
    },    {
        id: "phone3",
        label: "טלפון 3",
        numeric: false,
        priority: -1,
        hide: true,
        cellRenderer: ({params}) => {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
                >
                    {params?.value && <Typography variant="subtitle1">
                        <IconPhone size={12} strokeWidth={1} color='#000000'/> {params?.value}
                    </Typography>}
                </div>
            )
        },
        extractFunc: (row) => {
            if (row.id) {
                const client = JSDB().getClient(Number(row.id)).first;
                return client?.getThirdPhone() ?? '';
            }
            return ''

        },
    },
    {
        id: "c_category",
        label: "קטגורית לקוחות",
        numeric: false,
        priority: -1,
        hide: true,
        type:'numOrStr',
        enableRowGroup: true
    },
    {
        id: "cp_category",
        label: "קבוצת לקוחות",
        numeric: false,
        priority: -1,
        type:'numOrStr',
        hide: true,
        enableRowGroup: true
    },
    {
        id: "position",
        label: "סדר לקוחות",
        numeric: true,
        priority: -1,
        hide: true,

    },
    {
        id: "driver_position",
        label: "סדר נהגים",
        numeric: true,
        priority: -1,
        hide: true,
        // Editable even when the order is closed (readonly after delivery/invoice):
        // with נהג זמני / force_position the value lives on the order itself.
        editable: () => true,
        cellRenderer: ({params}) => {
            if (params?.node?.group || params?.node?.rowPinned) return params?.value ?? '';
            // Forced per-order position (OrderNote.force_position) — pin (not lock): still editable.
            if (params?.node?.data?.force_position_on) {
                return (
                    <Tooltip title="סדר מאולץ להזמנה — ניתן לעריכה גם כשההזמנה סגורה">
                        <span style={{display: 'flex', alignItems: 'center'}}>
                            {params?.value ?? ''} <PushPinIcon style={{marginRight: '5px', fontSize: '14px', color: '#00a5ff'}}/>
                        </span>
                    </Tooltip>
                );
            }
            return params?.value ?? '';
        }

    },
    {
        id: "collector_position",
        label: "סדר ליקוט",
        numeric: true,
        priority: -1,
        editable: (row) => {
            return true
        },
        hide: true,

    },
    {
        id: 'agent',
        numeric: false,
        label: 'שם קו',
        align: 'center',
        enableRowGroup: true,
        pinnedRowProps: {
            action: "uniqueCount"
        },
        editable: (row) => {
            return !row?.node?.data?.readonly
        },
        cellRenderer: ({params}) => {
            if (params?.node?.group) return params?.value || '';
            if (params?.node?.rowPinned) {
                return (
                    <span style={{
                        display: 'flex',
                        alignItems: "center",
                    }}>
                        {params?.value || ""} {params?.value ?
                        <RouteIcon style={{marginRight: "5px", color: "blue"}}/> : ""}
                    </span>
                )
            }
            return params?.value || '';
        }
    },
    {
        id: "car",
        label: "מס רכב",
        numeric: false,
        priority: -1,
        type: "string",
        hide: true,
        editable: (row) => {
            return !row?.node?.data?.readonly
        },
    },

    {
        id: 'driverName',
        numeric: false,
        label: 'נהג',
        align: 'center',
        enableRowGroup: true,
        pinnedRowProps: {
            action: "uniqueCount"
        },
        editable: (row) => {
            console.log(row)
            return row.data?.orderDriver==undefined
        },
        comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
            if (valueA == '') return -1
            if (valueB == '') return 1
            if (!valueA) return 1;
            if (!valueB) return -1;
            if (nodeA?.group || nodeB?.group) {
                return valueB.localeCompare(valueA);
            }
            if (valueA == valueB)
                return (nodeA?.data?.driver_position ?? 0) - (nodeB?.data?.driver_position ?? 0)
            return valueA.localeCompare(valueB)
        },
        extractFunc: (row) => {
          return row.orderDriver!=undefined ? row.orderDriver : row.driverName
        },
        cellRenderer: ({params}) => {
            if (params?.node?.group) return params?.value || '';
            if (params?.node?.rowPinned === "top") {
                return (
                    <span style={{
                        display: 'flex',
                        alignItems: "center",
                    }}>
                        {params?.value || ''} {params?.value ? <LocalShippingIcon style={{
                        marginRight: '5px',
                        color: '#00a5ff'
                    }}/> : undefined}
                    </span>
                )
            }
            return params?.value || '';
        },
    },
    {
        id: 'orderDriver',
        numeric: false,
        label: 'נהג זמני',
        align: 'center',
        hide: true,
        enableRowGroup: true,
        pinnedRowProps: {
            action: "uniqueCount"
        },
        editable: (row) => {
            return true
        },
        comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
            if (valueA == '') return -1
            if (valueB == '') return 1
            if (!valueA) return -1;
            if (!valueB) return 1;
            if (nodeA?.group || nodeB?.group) {
                return valueB.localeCompare(valueA);
            }
            if (valueA == valueB)
                (nodeA?.driver_position ?? 0) - (nodeB?.driver_position ?? 0)
            return valueB.localeCompare(valueA)
        },
        cellRenderer: ({params}) => {
            if (params?.node?.group) return params?.value || '';
            if (params?.node?.rowPinned === "top") {
                return (
                    <span style={{
                        display: 'flex',
                        alignItems: "center",
                    }}>
                        {params?.value || ''} {params?.value ? <LocalShippingIcon style={{
                        marginRight: '5px',
                        color: '#00a5ff'
                    }}/> : undefined}
                    </span>
                )
            }
            return params?.value || '';
        },
    },
    {
        id: 'collectorName',
        numeric: false,
        label: 'מלקט',
        hide: true,
        align: 'center',
        enableRowGroup: true,
        pinnedRowProps: {
            action: "uniqueCount"
        },
        editable: (row) => {
            return true
        },
        cellRenderer: ({params}) => {
            if (params?.node?.group) return params?.value || '';
            if (params?.node?.rowPinned === "top") {
                return (
                    <span style={{
                        display: 'flex',
                        alignItems: "center",
                    }}>
                        {params?.value || ''} {params?.value ? <Bucket style={{
                        marginRight: '5px',
                        color: '#000000'
                    }}/> : undefined}
                    </span>
                )
            }
            return params?.value || '';
        }
    },
    {
        id: 'street',
        numeric: false,
        label: 'רחוב',
        align: 'center',
        extendedSearchProperties: ['city', 'street', 'streetNumber'],
        searchQueryPlaceholder: 'עיר/כתובת',
        enableRowGroup: true,
        pinnedRowProps: {
            action: "uniqueCount"
        },
        // extractFunc: (row) => {
        //     const address = row?.street && row?.streetNumber ? `${row?.street}, ${row?.streetNumber}` : row?.street;
        //     return address
        //
        // },
        extractFunc: (row) => {
            if (!row?.id) return '';
            return getOrderRowAddressParts(row).full;
        },

    },
    {
        id: 'city',
        numeric: false,
        label: 'עיר',
        align: 'center',
        extendedSearchProperties: ['city', 'street', 'streetNumber'],
        searchQueryPlaceholder: 'עיר/כתובת',
        enableRowGroup: true,
        pinnedRowProps: {
            action: "uniqueCount"
        },
        extractFunc: (row) => {
            if (!row?.id) return '';
            return getOrderRowAddressParts(row).city;
        },

        cellRenderer: ({params}) => {
            if (params?.node?.group) return params?.value || '';
            if (params?.node?.rowPinned === "top") {
                return (
                    <span style={{
                        display: 'flex',
                        alignItems: "center",
                    }}>
                        {params?.value || ''} {params?.value ? <LocationCityIcon style={{
                        marginRight: '5px',
                        color: "brown"
                    }}/> : ""}
                    </span>
                )
            }
            const {city, street, streetNumber, isForced} = getOrderRowAddressParts(params?.data ?? {});
            const address = street && streetNumber ? `${street}, ${streetNumber}` : street;
            const location = isForced ? '' : (params?.data?.location ?? '');
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
                >
                    <>
                        {!city && !address && location == '' ? <div></div> : (
                            <>
                                <Typography variant="subtitle1">
                                    {' '}
                                    <MapPin size={14} strokeWidth={1} color="#000000"/> {city}
                                </Typography> <Typography variant="caption">{address}</Typography>
                            </>
                        )}
                    </>
                </div>
            )
        },
    },
    {
        id: 'externalId',
        numeric: false,
        label: 'מזהה חיצוני',
        hide: true,
        type:'numOrStr',
        align: 'center',
        extendedSearchProperties: ['externalId'],
        searchQueryPlaceholder: 'מזהה חיצוני'
    }, {
        id: 'ref_id',
        numeric: false,
        label: 'מזהה שכפול',
        type:'numOrStr',
        hide: true,
        align: 'center',
    },
    {
        id: 'mName',
        type: 'string',
        label: 'משטח',
        numeric: false,
        hide: true,
        align: 'center',
        type:'numOrStr',
        priority: -1,
        pinnedRowProps: {
            action: "uniqueCount"
        },
        enableRowGroup: true,
        editable: (row) => {
            return true
        },
        cellRenderer({params}) {
            if (params?.node?.group) return params?.value || '';
            if (params?.node?.rowPinned === "top") {
                return (
                    <span style={{
                        display: 'flex',
                        alignItems: "center",
                    }}>
                        {params?.value || ''} {params?.value ? <Package style={{
                        marginRight: '5px',
                        color: "#dc6c00"
                    }}/> : ""}
                    </span>
                )
            }
            return params?.value || '';
        },
    },
    {
        id: "debt",
        label: "חוב לקוח",
        numeric: false,
        hide: true,
        priority: -1,
        extractFunc: (row) => {
            if (row.id) {
                const client = JSDB().getClient(Number(row.id)).first;
                const wall = client?.debtWall
                return wall ? roundDecimals(wall?.moneyOut - wall?.moneyIn) : undefined;

            } else
                return undefined

        },
    },
    {
        id: "obligo",
        label: "אובליגו",
        numeric: false,
        hide: true,
        priority: -1,
        extractFunc: (row) => {
            if (row.id) {
                const client = JSDB().getClient(Number(row.id)).first;
                return client?.obligo

            } else
                return undefined

        },
    },
    {
        id: "payment_notes",
        label: "תנאי תשלום",
        numeric: false,
        hide: true,
        priority: -1,
        extractFunc: (row) => {
            if (row.id) {
                const client = JSDB().getClient(Number(row.id)).first;
                return client?.payment_notes

            } else
                return undefined

        },
    },


];

interface orderFilters {
    agents: Filter[];
    collectors: Filter[];
    drivers: Filter[];
    clients: Filter[];
    cities: Filter[];
    categories: Filter[];
    orders: Filter[];
    order_assistent: Filter[];
    dvs: Filter[];
    products: Filter[];
    productsCategories: Filter[];
    days: Filter[];
}

const compareProductPosition = (a: Product, b: Product): number => {
    const aPosition = Number(a.position);
    const bPosition = Number(b.position);
    const normalizedA = Number.isFinite(aPosition) ? aPosition : Number.MAX_SAFE_INTEGER;
    const normalizedB = Number.isFinite(bPosition) ? bPosition : Number.MAX_SAFE_INTEGER;

    return normalizedA - normalizedB || Number(a.id) - Number(b.id);
};

const OrdersDataSheet2 = ({
                              setFiltersToMasterFilter,
                              products,
                              agentsNames,
                              collectorsNames,
                              driversNames,
                              date,
                              toDate,
                              activeState,

                              tempData, setTempData,
                              updatedRowIds,
                              updatedDriverRowIds,
                              callPrevOrder,
                              callPrevDaily,
                              statuses,

                              setSingleDelete,
                              deleteOrder,
                              saveOrder,
                              openDrawer,
                              handleOpenDrawer,
                              setDrawerSingleData,
                              activeRow,
                              setActiveRow,

                              setAll,

                              restoreAllChanges,
                              dvs_flag,
                              setDvsFlag,
                              showProducts,
                              setShowProducts,
                              orderFilters,
                              onApplyFilter,
                              showData,
                              sortBy,
                              setOpenDrawer,
                              handleApplySort,
                              addCustomerFilter,
                              removeAllFilters,
                              setOpenStatistics,
                              openStatistics,
                              setActiveP, cancelDV,
                              applyCanceledDocument,
                              refreshRowIds,
                              distinctStatus,
                              reorderDrivers,
                              setReorderDrivers,
                              clearEditFromAbove,
                              fullInventory,
                              pinnedInventoryEditable,
                              setPinnedInventoryEditable,
                              pinnedInventoryEditable2,
                              setPinnedInventoryEditable2,
                              pinnedOldInventoryEditable,
                              setPinnedOldInventoryEditable,
                              callClientVisit,
                              clientVisit,
                              setRefreshRowIds,
                              onRemoveFilter,
                              newClientOrder,
                              transferClientOrder,
                              externalIdSearch,
                              refreshClientData,
                              tableRef,
                              setHistoryState,
                                historyState,
                              previewOpen,
                              setPreviewOpen,
                              onOpenSyncConflict,
                          }: {
    setFiltersToMasterFilter: (activeFiltersKey: string, filterId: string, label?: string) => void,
    products: Product[];
    agentsNames: string[];
    collectorsNames: string[];
    driversNames: string[];
    date: Date,
    toDate?: Date | null,
    activeState: OrderActiveState,
    tempData: OrderData[],
    setTempData: any,
    callPrevOrder: any,
    updatedRowIds: any,
    updatedDriverRowIds: any,
    callPrevDaily: any,
    statuses: any[]

    setSingleDelete: any,
    deleteOrder: any,
    saveOrder: any,
    openDrawer: any,
    setOpenDrawer: any,
    handleOpenDrawer: any,
    setDrawerSingleData: any,
    activeRow: any,
    setActiveRow: any,

    setAll: any

    restoreAllChanges: any
    dvs_flag: boolean
    setDvsFlag: any
    showProducts: any,
    setShowProducts: any
    orderFilters: orderFilters
    onApplyFilter: any
    showData: any,
    sortBy: any,

    handleApplySort: any
    addCustomerFilter: any
    removeAllFilters: any,
    setOpenStatistics: any,
    openStatistics: any,
    cancelDV: any,
    applyCanceledDocument?: (original: any, result?: any) => void,
    refreshRowIds: any,
    setActiveP,
    distinctStatus,
    reorderDrivers,
    setReorderDrivers,
    clearEditFromAbove: any,
    fullInventory: any,
    pinnedInventoryEditable: any,
    setPinnedInventoryEditable: any,
    pinnedInventoryEditable2:any,
    setPinnedInventoryEditable2:any,
    pinnedOldInventoryEditable: any,
    setPinnedOldInventoryEditable: any,
    callClientVisit: any,
    clientVisit,
    setRefreshRowIds: any,
    newClientOrder: any,
    transferClientOrder: any,
    refreshClientData: any,
    externalIdSearch: boolean
    tableRef: MutableRefObject<any>
    onRemoveFilter: any,
    setHistoryState:any,
    historyState:any,
    previewOpen: any,
    setPreviewOpen: any,
    onOpenSyncConflict?: (row: OrderData) => void,
}) => {
    const theme = useTheme();
    const dispatch = useDispatch();

    const [selectedCustomersSend, setSelectedCustomersSend] = React.useState<any>(undefined)
    const [reorderDialog, setReorderDialog] = React.useState<any>(undefined)
    const [distributeDialogOn, setDistributeDialogOn] = React.useState<any>(undefined)
    const [driverLinkRows, setDriverLinkRows] = React.useState<OrderData[] | undefined>(undefined);
    const [persistentDriverLinkRows, setPersistentDriverLinkRows] = React.useState<OrderData[] | undefined>(undefined);
    const [disableKeyBoard, setDisableKeyBoard] = React.useState(false);
    const [color_surface, setColorSurface] = React.useState(true);
    const [show_collectors, setShowCollector] = React.useState(parseInt(localStorage.getItem('show_collectors') ?? '0') == 1);
    const [openCustomerDrawer, setOpenCustomerDrawer] = React.useState(false);
    const textToDataAi = useTextToDataAiAvailability();
    const aiAssistant = useAiAssistantAvailability();
    const aiDraftsAvailable = textToDataAi.available && aiAssistant.available;
    // console.log('customers/order-list' + `-inventory_${dateObjectToString(date)}`)
    // const [pinnedInventoryEditable, setPinnedInventoryEditable] = React.useState(JSON.parse(localStorage.getItem('customers/order-list' + `-inventory_${dateObjectToString(date)}`) ?? `{"customer":"מלאי ידני"}`));
    // const [pinnedOldInventoryEditable, setPinnedOldInventoryEditable] = React.useState(JSON.parse(localStorage.getItem('customers/order-list' + `-inventory_old_${dateObjectToString(date)}`) ?? `{"customer":"מלאי ישן"}`));

    const [selectedCustomerId, setSelectedCustomerId] = React.useState(undefined);
    const [displayProductsWithValues, setDisplayProductsWithValues] = React.useState(true);
    React.useEffect(() => {
        const key = 'customers/order-list' + `-inventory_${dateObjectToString(date)}`;
        if (pinnedInventoryEditable.hasBeenEdited) {
            localStorage.setItem(key, JSON.stringify(pinnedInventoryEditable));
        } else {
            localStorage.removeItem(key);
        }
    }, [pinnedInventoryEditable, date])
    React.useEffect(() => {
        const key = 'customers/order-list' + `-inventory_old_${dateObjectToString(date)}`;
        if (pinnedOldInventoryEditable.hasBeenEdited) {
            localStorage.setItem(key, JSON.stringify(pinnedOldInventoryEditable));
        } else {
            localStorage.removeItem(key);
        }
    }, [pinnedOldInventoryEditable, date])
    React.useEffect(() => {
        const key = 'customers/order-list' + `-inventory2_${dateObjectToString(date)}`;
        if (pinnedInventoryEditable2.hasBeenEdited) {
            localStorage.setItem(key, JSON.stringify(pinnedInventoryEditable2));
        } else {
            localStorage.removeItem(key);
        }
    }, [pinnedInventoryEditable2, date])

    const [debtLoad, setDebtLoad] = React.useState<boolean>(false);
    React.useEffect(() => {
        if (debtLoad) {
            buildClientCartesetDebt(new Date()).then(r =>

                setRefreshRowIds(new Set(tempData.map((t) => orderKey(t)))))
        } else {

        }
    }, [debtLoad]);
    const [cols, setCols] = React.useState<HeadCell[]>(headCells);
    const orderedProducts = React.useMemo(
        () => products.slice().filter((product) => {
            const categoryFilter =
                orderFilters.productsCategories.length === 0 ||
                orderFilters.productsCategories[0].values.some(
                    (value) => value === product.category || value === product.category2
                );
            const productFilter =
                orderFilters.products.length === 0 ||
                orderFilters.products[0].values.some((value) => value === product.name);
            return categoryFilter && productFilter;
        }).sort(compareProductPosition),
        [products, orderFilters.productsCategories, orderFilters.products]
    );
    const productColumnPrefix = JSDB().getCompany() === 'pommeranz' ? 'rrp_' : 'p_';
    const canonicalProductColumnOrder = React.useMemo(
        () => showProducts ? orderedProducts.map((product) => `${productColumnPrefix}${product.id}`) : [],
        [showProducts, orderedProducts, productColumnPrefix]
    );
    useEffect(() => {

        localStorage.setItem('show_collectors', show_collectors ? '1' : '0');

    }, [show_collectors]);

    React.useEffect(() => {
        const newCols = cloneDeep((headCells))
        const notes2 =  JSDB().getUser().first?.getJsonDesc("notes2")
        if (notes2) {
            newCols.push(    {
                id: "notes2",
                label: notes2.name,
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                editable: (row) => {
                    return true
                },
            },)
        } else {
            newCols.push(    {
                id: "notes2",
                label: "הערות 2",
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                editable: (row) => {
                    return true
                },
            })
        }
        const notes3 =  JSDB().getUser().first?.getJsonDesc("notes3")
        if (notes3) {
            newCols.push(    {
                id: "notes3",
                label: notes3.name,
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                editable: (row) => {
                    return true
                },
            },)
        } else {
            newCols.push(    {
                id: "notes3",
                label: "הערות 3",
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                editable: (row) => {
                    return true
                },
            })
        }
        const notes4 =  JSDB().getUser().first?.getJsonDesc("notes4")
        if (notes4) {
            newCols.push(    {
                id: "notes4",
                label: notes4.name,
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                editable: (row) => {
                    return true
                },
            },)
        } else {
            newCols.push(    {
                id: "notes4",
                label: "הערות 4",
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                editable: (row) => {
                    return true
                },
            })
        }

        const notes5 = JSDB().getUser().first?.getJsonDesc("notes5")
        if (notes5) {
            newCols.push(    {
                id: "notes5",
                label: notes5.name,
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                editable: (row) => {
                    return true
                },
            },)
            newCols.push(    {
                id: "notes5Dv",
                label: "הערות 5 תעודה",
                numeric: false,
                hide: true,
                priority: -1,
                extractFunc: (row) => {
                    if (row.dvs?.[0]?.notes5) {
                        return row.dvs?.[0]?.notes5

                    } else
                        return undefined

                },

            },)
        } else {
            newCols.push(    {
                id: "notes5",
                label: "הערות 5",
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                editable: (row) => {
                    return true
                },
            })
            newCols.push(    {
                id: "notes5Dv",
                label: "הערות 5 תעודה",
                numeric: false,
                hide: true,
                priority: -1,

                extractFunc: (row) => {
                    if (row.dvs?.[0]?.notes5) {
                        return row.dvs?.[0]?.notes5

                    } else
                        return undefined

                },

            })

        }

        const notes6 = JSDB().getUser().first?.getJsonDesc("notes6")
        if (notes6) {
            newCols.push({
                id: "notes6",
                label: notes6.name,
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                editable: (row) => {
                    return true
                },
            },)
        } else {
            newCols.push({
                id: "notes6",
                label: "הערות 6",
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                editable: (row) => {
                    return true
                },
            })
        }
        const notes7 = JSDB().getUser().first?.getJsonDesc("notes7")
        if (notes7) {
            newCols.push({
                id: "notes7",
                label: notes7.name,
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                editable: (row) => {
                    return true
                },
            },)
        } else {
            newCols.push({
                id: "notes7",
                label: "הערות 7",
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                editable: (row) => {
                    return true
                },
            })
        }
        const notes8 = JSDB().getUser().first?.getJsonDesc("notes8")
        if (notes8) {
            newCols.push({
                id: "notes8",
                label: notes8.name,
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                editable: (row) => {
                    return true
                },
            },)
        } else {
            newCols.push({
                id: "notes8",
                label: "הערות 8",
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                editable: (row) => {
                    return true
                },
            })
        }
        const notes9 = JSDB().getUser().first?.getJsonDesc("notes9")
        if (notes9) {
            newCols.push({
                id: "notes9",
                label: notes9.name,
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                editable: (row) => {
                    return true
                },
            },)
        } else {
            newCols.push({
                id: "notes9",
                label: "הערות 9",
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                editable: (row) => {
                    return true
                },
            })
        }
        const notes10 = JSDB().getUser().first?.getJsonDesc("notes10")
        if (notes10) {
            newCols.push({
                id: "notes10",
                label: notes10.name,
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                editable: (row) => {
                    return true
                },
            },)
        } else {
            newCols.push({
                id: "notes10",
                label: "הערות 10",
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                editable: (row) => {
                    return true
                },
            })
        }
        const cnotes2 =  JSDB().getUser().first?.getJsonDesc("cnotes2")
        if (cnotes2) {
            newCols.push(    {
                id: "cnotes2",
                label: cnotes2.name,
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                editable: (row) => {
                    return true
                },
            },)
        } else {
            newCols.push(    {
                id: "cnotes2",
                label: "הערות לקוח 2",
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                extractFunc: (row) => {
                    if (row.id) {
                        const client = JSDB().getClient(Number(row.id)).first;
                        return client?.notes2

                    } else
                        return undefined

                },
            })
        }
        const cnotes3 =  JSDB().getUser().first?.getJsonDesc("cnotes3")
        if (cnotes3) {
            newCols.push(    {
                id: "cnotes3",
                label: cnotes3.name,
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                extractFunc: (row) => {
                    if (row.id) {
                        const client = JSDB().getClient(Number(row.id)).first;
                        return client?.notes3

                    } else
                        return undefined

                },
            },)
        } else {
            newCols.push(    {
                id: "cnotes3",
                label: "הערות לקוח 3",
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                extractFunc: (row) => {
                    if (row.id) {
                        const client = JSDB().getClient(Number(row.id)).first;
                        return client?.notes2

                    } else
                        return undefined

                },
            })
        }
        const cnotes4 =  JSDB().getUser().first?.getJsonDesc("cnotes4")
        if (cnotes4) {
            newCols.push(    {
                id: "cnotes4",
                label: cnotes4.name,
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                extractFunc: (row) => {
                    if (row.id) {
                        const client = JSDB().getClient(Number(row.id)).first;
                        return client?.notes4

                    } else
                        return undefined

                },
            },)
        } else {
            newCols.push(    {
                id: "cnotes4",
                label: "הערות לקוח 4",
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                extractFunc: (row) => {
                    if (row.id) {
                        const client = JSDB().getClient(Number(row.id)).first;
                        return client?.notes4

                    } else
                        return undefined

                },
            })
        }
        const cnotes5 =  JSDB().getUser().first?.getJsonDesc("cnotes5")
        if (cnotes5) {
            newCols.push(    {
                id: "cnotes5",
                label: cnotes5.name,
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                extractFunc: (row) => {
                    if (row.id) {
                        const client = JSDB().getClient(Number(row.id)).first;
                        return client?.notes5

                    } else
                        return undefined

                },
            },)
        } else {
            newCols.push(    {
                id: "cnotes5",
                label: "הערות לקוח 5",
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                extractFunc: (row) => {
                    if (row.id) {
                        const client = JSDB().getClient(Number(row.id)).first;
                        return client?.notes5

                    } else
                        return undefined

                },
            })
        }
        const cnotes6 =  JSDB().getUser().first?.getJsonDesc("cnotes6")
        if (cnotes6) {
            newCols.push(    {
                id: "cnotes6",
                label: cnotes6.name,
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                extractFunc: (row) => {
                    if (row.id) {
                        const client = JSDB().getClient(Number(row.id)).first;
                        return client?.notes6

                    } else
                        return undefined

                },
            },)
        } else {
            newCols.push(    {
                id: "cnotes6",
                label: "הערות לקוח 6",
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                extractFunc: (row) => {
                    if (row.id) {
                        const client = JSDB().getClient(Number(row.id)).first;
                        return client?.notes6

                    } else
                        return undefined

                },
            })
        }
        const cnotes7 =  JSDB().getUser().first?.getJsonDesc("cnotes7")
        if (cnotes7) {
            newCols.push(    {
                id: "cnotes7",
                label: cnotes7.name,
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                extractFunc: (row) => {
                    if (row.id) {
                        const client = JSDB().getClient(Number(row.id)).first;
                        return client?.notes7

                    } else
                        return undefined

                },
            },)
        } else {
            newCols.push(    {
                id: "cnotes7",
                label: "הערות לקוח 7",
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                extractFunc: (row) => {
                    if (row.id) {
                        const client = JSDB().getClient(Number(row.id)).first;
                        return client?.notes7

                    } else
                        return undefined

                },
            })
        }
        const cnotes8 =  JSDB().getUser().first?.getJsonDesc("cnotes8")
        if (cnotes8) {
            newCols.push(    {
                id: "cnotes8",
                label: cnotes8.name,
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                extractFunc: (row) => {
                    if (row.id) {
                        const client = JSDB().getClient(Number(row.id)).first;
                        return client?.notes8

                    } else
                        return undefined

                },
            },)
        } else {
            newCols.push(    {
                id: "cnotes8",
                label: "הערות לקוח 8",
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                extractFunc: (row) => {
                    if (row.id) {
                        const client = JSDB().getClient(Number(row.id)).first;
                        return client?.notes8

                    } else
                        return undefined

                },
            })
        }
        const cnotes9 =  JSDB().getUser().first?.getJsonDesc("cnotes9")
        if (cnotes9) {
            newCols.push(    {
                id: "cnotes9",
                label: cnotes9.name,
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                extractFunc: (row) => {
                    if (row.id) {
                        const client = JSDB().getClient(Number(row.id)).first;
                        return client?.notes9

                    } else
                        return undefined

                },
            },)
        } else {
            newCols.push(    {
                id: "cnotes9",
                label: "הערות לקוח 9",
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                extractFunc: (row) => {
                    if (row.id) {
                        const client = JSDB().getClient(Number(row.id)).first;
                        return client?.notes9

                    } else
                        return undefined

                },
            })
        }
        const cnotes10 =  JSDB().getUser().first?.getJsonDesc("cnotes10")
        if (cnotes10) {
            newCols.push(    {
                id: "cnotes10",
                label: cnotes10.name,
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                extractFunc: (row) => {
                    if (row.id) {
                        const client = JSDB().getClient(Number(row.id)).first;
                        return client?.notes10

                    } else
                        return undefined

                },
            },)
        } else {
            newCols.push(    {
                id: "cnotes10",
                label: "הערות לקוח 10",
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                extractFunc: (row) => {
                    if (row.id) {
                        const client = JSDB().getClient(Number(row.id)).first;
                        return client?.notes10

                    } else
                        return undefined

                },
            })
        }
        const cnotes11 =  JSDB().getUser().first?.getJsonDesc("cnotes11")
        if (cnotes11) {
            newCols.push(    {
                id: "cnotes11",
                label: cnotes11.name,
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                extractFunc: (row) => {
                    if (row.id) {
                        const client = JSDB().getClient(Number(row.id)).first;
                        return client?.notes11

                    } else
                        return undefined

                },
            },)
        } else {
            newCols.push(    {
                id: "cnotes11",
                label: "הערות לקוח 11",
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                extractFunc: (row) => {
                    if (row.id) {
                        const client = JSDB().getClient(Number(row.id)).first;
                        return client?.notes11

                    } else
                        return undefined

                },
            })
        }
        const cnotes12 =  JSDB().getUser().first?.getJsonDesc("cnotes12")
        if (cnotes12) {
            newCols.push(    {
                id: "cnotes12",
                label: cnotes12.name,
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                extractFunc: (row) => {
                    if (row.id) {
                        const client = JSDB().getClient(Number(row.id)).first;
                        return client?.notes12

                    } else
                        return undefined

                },
            },)
        } else {
            newCols.push(    {
                id: "cnotes12",
                label: "הערות לקוח 12",
                numeric: false,
                hide: true,
                priority: -1,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                extractFunc: (row) => {
                    if (row.id) {
                        const client = JSDB().getClient(Number(row.id)).first;
                        return client?.notes12

                    } else
                        return undefined

                },
            })
        }
        const arr = [...(showProducts ? orderedProducts.map((p) => ({
            id: `${productColumnPrefix}${p.id}`,
            type: 'number' as const,
            numeric: true,
            editable: (row: any) => {
                return !row?.node?.data?.readonly
            },
            aggFunc: 'sum' as const,
            pinnedRowProps: {
                action: "sum",
            },

            label: (p.orderName && p.orderName.length > 0) ? p.orderName : p.name,
            valueLimit: {
                min: 0,
            },
            cellRenderer({params}: { params: any }) {
                const rowUnit = params?.node?.data?.[`u_${p.id}`];
                const isBox = rowUnit === 1;
                // order-only third unit (no conversion, never charged): give it its own icon so it's
                // visually distinguishable from the second (Package) unit right in the main grid,
                // without needing to open the drawer just to tell which unit an amount is in.
                const isThird = rowUnit === 2;
                return (
                    <>
                        {isBox ? <Package style={{
                            marginRight: '5px',
                            color: "black",
                            width: "14px",
                            height: "14px",

                        }}/> : ""}
                        {isThird ? <Tag style={{
                            marginRight: '5px',
                            color: "black",
                            width: "14px",
                            height: "14px",

                        }}/> : ""}
                        {params?.value == null || params?.value === '' ? '' : params.value}
                    </>
                )
            }
        } as HeadCell)) : [])]

        if(show_collectors) {
            const cc = JSDB().getCollectors().first
            if (cc.size > 0) {
                cc.toArray().forEach((c) => {
                    newCols.push({
                        id: `c_${c.id}`,
                        type: 'number',
                        numeric: true,
                        aggFunc: 'sum',
                        pinnedRowProps: {
                            action: "sum",
                        },
                        editable:true,
                        label: c.user_name,

                    })

                })

                if(JSDB().getCompany()=='misrael') {

                    const category2 = JSDB().getKartonCategories()
                    if(category2.size>0)
                        category2.toArray().forEach((p) => {
                        newCols.push({
                            id: `c_${p}`,
                            type: 'number',
                            numeric: true,
                            editable: (row) => {
                                return false
                            },
                            aggFunc: 'sum',
                            pinnedRowProps: {
                                action: "sum",
                            },
                            label: p,

                        })
                    })
                }
            }
        }

        if (hasExternalSoftwareIntegration()) {
            newCols.push({
                id: 'erpSent',
                numeric: false,
                label: 'נשלח לתוכנה',
                align: 'center',
                hide: true,
                filterable: true,
                extendedSearchProperties: ['כן נשלח', 'לא נשלח'],
                extractFunc: (row) => getRowExternalSoftwareSentStatus(row),
                searchFunc: (row) => {
                    const status = getRowExternalSoftwareSentStatus(row);
                    return status ? [status] : [];
                },
                cellRenderer({params, setTempData}) {
                    if (params?.node?.group || params?.node?.rowPinned) return params?.value ?? '';
                    const value = params?.value;
                    if (!value) return '';
                    return (
                        <ErpSentChip
                            row={params?.node?.data}
                            gridApi={params?.api}
                            setTempData={setTempData}
                            value={value}
                        />
                    );
                },
            });
        }

        newCols.push(
            ...arr
        );

        setCols(newCols)
    }, [showProducts, show_collectors, orderedProducts, productColumnPrefix])

    const [documentAction, setDocumentAction] = React.useState(undefined);
    const openOrders = useOpenOrders2();
    const inventoryDup = putInventoryNextDay();
    //
    // React.useEffect(() => {
    //     handleApplySort(sortBy.orderBy, sortBy.order, sortBy.property2);
    // }, [orderFilters]);

    const [menuItems, setMenuItems] = React.useState<{
        agent: {
            label: string,
            value: string
        }[],
        driverName: {
            label: string,
            value: string
        }[],
        orderDriver: {
            label: string,
            value: string
        }[],
        status: {
            label: string,
            value: string
        }[],
        collectorName: {
            label: string,
            value: string
        }[],
    }>({
        agent: [],
        driverName: [],
        orderDriver: [],
        status: [],
        collectorName: []
    })

    React.useEffect(() => {
        const newMenuItems = {
            agent: [],
            driverName: [],
            status: [],
            collectorName: [],
            orderDriver: []
        }
        newMenuItems.agent = (agentsNames as any).map((a) => ({
            label: a,
            value: a
        }))
        newMenuItems.driverName = (driversNames as any).map((a) => ({
            label: a,
            value: a
        }))
        newMenuItems.orderDriver = (driversNames as any).map((a) => ({
            label: a,
            value: a
        }))
        newMenuItems.status = (distinctStatus as any).map((a) => ({
            label: a,
            value: a
        }))
        newMenuItems.collectorName = (collectorsNames as any).map((a) => ({
            label: a,
            value: a
        }))
        setMenuItems(newMenuItems)
    }, [agentsNames, driversNames, distinctStatus, collectorsNames])

    const [openCustomeRangePicker, setOpenCustomeRangePicker] = React.useState(false);
    const [withOrdersFilter, setWithOrdersFilter] = React.useState(orderFilters?.orders?.length);
    useEffect(() => {
        setWithOrdersFilter(orderFilters?.orders?.length);
    }, [orderFilters])

    const [productChipMoved, setProductChipMoved] = React.useState(false);

    // Detect clients with duplicate orders (more than one order per client)
    const duplicateClients = useMemo(() => {
        try {
            const perClient: Record<string, Set<string>> = {};
            tempData?.forEach((row: any) => {
                const cid = row?.id;
                const oid = row?.orderId;
                if (!cid) return;
                if (!perClient[cid]) perClient[cid] = new Set<string>();
                if (oid && String(oid).length > 0) perClient[cid].add(String(oid));
            });
            const res = new Set<number>();
            Object.keys(perClient).forEach((k) => {
                if (perClient[k].size > 1) res.add(Number(k));
            });
            return res;
        } catch (e) {
            return new Set<number>();
        }
    }, [tempData]);
    const hasDuplicateOrders = duplicateClients.size > 0;

    const duplicateOrdersFilterActive = useMemo(() => {
        try {
            return Boolean(orderFilters?.orders?.some((f: any) => f?.property === 'duplicateOrders'));
        } catch (_) {
            return false;
        }
    }, [orderFilters]);

    const onColumnMoveCallback = React.useCallback((params) => {
        params?.columns?.some((col) => {
            if (col?.colDef?.id?.startsWith("p_")) {
                setProductChipMoved(true);
            }
        });
    }, []);

    const chipDetails = useMemo(() => {
        const chips = [
            ...(aiDraftsAvailable ? [{
                action: () => aiOpenDocsManager(),
                label: () => 'טעינה AI',
                icon: <AutoFixHighIcon/>,
                tooltip: 'פתיחת מסך טיוטות AI (מסמכים)',
                active: () => false,
            }] : []),
            // Warning chip for duplicate orders per client
            ...(hasDuplicateOrders ? [{
                action: () => {
                    // Toggle duplicate orders filter and register in master filter
                    if (duplicateOrdersFilterActive) {
                        onRemoveFilter({
                            property: 'duplicateOrders',
                            contains: '',
                            custom: (d) => duplicateClients.has(Number(d?.id))
                        });
                    } else {
                        console.log(duplicateClients)
                        onApplyFilter({
                            property: 'duplicateOrders',
                            contains: '',
                            custom: (d) => duplicateClients.has(Number(d?.id))
                        });
                    }
                    setFiltersToMasterFilter('orders', 'duplicateOrders', 'הזמנות כפולות', (d) => duplicateClients.has(Number(d?.id)));
                },
                label: () => 'הזמנות כפולות',
                icon: <WarningAmberIcon/>,
                tooltip: 'נמצאו לקוחות עם יותר מהזמנה אחת. לחץ כדי לסנן',
                active: () => duplicateOrdersFilterActive || hasDuplicateOrders,
            }] : []),
            {
                label: (params) => customGroupLabelForChip(params, ["driverName"], "קבץ לפי נהגים", "הסר קיבוץ לפי נהגים"),
                action: (params) => {
                    const columnsState = params?.columnApi?.getColumnState();
                    const isGrouped = columnsState.find(c => c.colId.split("_")[0] === "driverName")?.rowGroup;
                    if (isGrouped) {
                        removeDragFromTable(params);
                    } else {
                        addDragToTable(params);
                    }
                    customGroup(params, ["driverName"]);
                },
                tooltip: "קבץ לפי נהגים",
                icon: <LocalShippingIcon/>,
            },
            {
                action: (params) => {
                    if (showProducts) {
                        setCols(headCells)
                        setShowProducts(false)
                    } else {
                        setShowProducts(true)
                    }

                },
                label: () => showProducts ? "הסתר מוצרים" : "הצג מוצרים",
                icon: <IconInfoCircle/>,
                tooltip: "הצג מוצרים בטבלה",
                active: () => showProducts,
            },
            {
                action: (params) => {
                    const allColsObj = {};
                    params?.columnApi?.getColumns().filter(col => col?.colDef?.id?.includes("p_"))?.forEach((col) => {
                        allColsObj[col.colDef.id] = col
                    });
                    let columnsWithValue = {};
                    params?.api?.forEachNodeAfterFilterAndSort((node) => {
                        if (node?.data) {
                            Object.keys(node.data).forEach((col) => {
                                if (col.startsWith("p_")) {
                                    if (node.data?.[col] && !columnsWithValue?.[col]) {
                                        columnsWithValue = {
                                            ...columnsWithValue,
                                            [col]: true,
                                        };
                                    }
                                }
                            });
                        }
                        if (node?.childrenAfterGroup) {
                            node?.childrenAfterGroup?.forEach((child) => {
                                Object.keys(child.data).forEach((col) => {
                                    if (col.startsWith("p_")) {
                                        if (child.data?.[col] && !columnsWithValue?.[col]) {
                                            columnsWithValue = {
                                                ...columnsWithValue,
                                                [col]: true,
                                            };
                                        }
                                    }
                                });
                            })
                        }
                    });
                    if (displayProductsWithValues) {
                        setDisplayProductsWithValues(false);
                        Object.keys(allColsObj).forEach((col) => {
                            if (!columnsWithValue?.[col]) {
                                params?.columnApi?.setColumnVisible(col, false);
                            }
                        });
                    } else {
                        setDisplayProductsWithValues(true);
                        Object.keys(allColsObj).forEach((col) => {
                            params?.columnApi?.setColumnVisible(col, true);
                        });
                    }


                },
                label: () => displayProductsWithValues ? "סנן מוצרים ללא ערך" : "הצג את כל המוצרים",
                icon: <IconInfoCircle/>,
                tooltip: "סנן מוצרים ללא ערך"
            },
            // {
            //     action: () => {
            //         setColorSurface((p) => !p);
            //         // re render the table
            //         // setCols((p) => [...p]);
            //     },
            //     label: () => color_surface ? "ללא צביעת משטחים" : "צבע משטחים",
            //     icon: <IconInfoCircle />,
            //     tooltip: "צבע משטחים"
            // },
            {
                action: () => {

                    setOpenStatistics((p) => {
                        return p ? undefined : {
                            open: true,
                            fromDate: undefined,
                            toDate: undefined,
                            name: 'orders-customer-statistics'
                        }

                    })
                },
                label: () => openStatistics ?
                    <span id="orders-customer-statistics">הסתר סטטיסטיקה</span> : "הצג סטטיסטיקה",
                icon: <IconInfoCircle/>,
                tooltip: "הצג סטטיסטיקה",
                active: () => openStatistics,
            },
            {
                action: () => {
                    if (activeState.day == -1) {
                        if (updatedRowIds.size > 0 && dvs_flag) {
                            Swal.fire({
                                title: 'ישנם שינויים ששית במצב תעודות',
                                text: 'מעבר למצב רגיל מוחק את השינויים האם אתה בטוח?',
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: theme.palette.primary.main,
                                cancelButtonColor: theme.palette.error.main,
                                confirmButtonText: 'עבור',
                                cancelButtonText: 'בטל'
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    /* Perform insert, update, and delete to the database here */
                                    restoreAllChanges();
                                    setDvsFlag((p) => !p);
                                }
                            });
                        } else {
                            restoreAllChanges();
                            setDvsFlag((p) => !p);
                        }
                    }
                },
                label: () => "הנפקת תעודת משלוח גורפת",
                icon: <IconInfoCircle/>,
                tooltip: "הנפקת תעודת משלוח גורפת"
            },

            {
                action: () => {
                    if (clientVisit) {
                        callClientVisit(null)
                    } else
                        setOpenCustomeRangePicker((p) => true)
                },
                label: () => <span id="orders-customer-range">פילטר לקוחות מזמינים</span>,
                icon: <CalendarMonth/>,
                tooltip: "סנן לפי תאריכים",
                active: () => clientVisit,
            },
            {
                action: (params) => {
                    if (show_collectors) {
                        setShowCollector(false)
                    } else {
                        setShowCollector(true)
                    }

                },
                label: () => show_collectors ? "הסתר מלקטים" : "הצג מלקטים",
                icon: <IconInfoCircle/>,
                tooltip: "הצג מלקטים בטבלה",
                active: () => show_collectors,
            },
            {
                action: (params) => {
                    setDebtLoad(true)
                },
                label: (params) => "משוך חוב לקוח",
                icon: <IconInfoCircle/>,
                tooltip: "עדכן חוב לקוח",
                active: (params) => true
            },

            {
                action: () => {
                    if (withOrdersFilter) {
                        onRemoveFilter({
                            property: 'withOrders',
                            contains: '',
                            custom: (d) => Boolean(d?.orderId) || Boolean(d?.hasBeenEdited)
                        });
                    } else {
                        onApplyFilter({
                            property: 'withOrders',
                            contains: '',
                            custom: (d) => Boolean(d?.orderId) || Boolean(d?.hasBeenEdited)
                        });
                    }
                    setFiltersToMasterFilter("orders", "withOrders", 'לקוחות עם הזמנות');
                },
                label: () => <span id="orders-with-orders-filter">
                    {
                        withOrdersFilter ? "הצג את כל הלקוחות" : "הצג לקוחות עם הזמנות"
                    }
                </span>,
                icon: <IconInfoCircle/>,
                tooltip: "הצג לקוחות עם הזמנות",
                active: () => withOrdersFilter,
            }
        ];

        // if (productChipMoved) {
        //     const saveProductsOrder = {
        //         action: (params) => {
        //             const productIds: number[] = [];
        //             params?.columnApi?.getColumnState()?.forEach(col => {
        //                 if (col?.colId?.startsWith("p_")) {
        //                     const id = col?.colId?.split("_")[1];
        //                     productIds.push(Number(id));
        //                 }
        //             });
        //             dispatch(updateMassCustomerProduct({
        //                 ids: productIds,
        //                 position: 1
        //             }));
        //             setProductChipMoved(false);
        //         },
        //         label: () => "שמור סדר מוצרים",
        //         icon: <DeviceFloppy/>,
        //         tooltip: "שמור סדר מוצרים",
        //         active: () => false,
        //     };
        //     chips.unshift(saveProductsOrder);
        // }

        return chips;
    }, [activeState, updatedRowIds, dvs_flag, showProducts, color_surface, openStatistics, displayProductsWithValues, clientVisit, withOrdersFilter, productChipMoved,show_collectors,duplicateClients, aiDraftsAvailable]);

    const saveDataCallback = React.useCallback(async (data) => {
        try {
            return await saveOrder(data.map((d) => d.id))
        } catch (e) {
            console.log(e)
            return false
        }

    }, [saveOrder])

    const tempDataRef = React.useRef(tempData);
    React.useEffect(() => {
        tempDataRef.current = tempData;
    }, [tempData]);

    const openDrawerForOrderRow = React.useCallback((row: OrderData, tableApi?: any) => {
        if (!row?.id) return;
        // Row id is the order key. A sorted grid can still hand back another row of the same
        // client when ids collide, so only trust a node that is this order.
        let node = tableApi?.getRowNode?.(orderKey(row));
        if (node && String(node.data?.orderId ?? '') !== String(row.orderId ?? '')) {
            node = undefined;
        }
        if (!node && tableApi?.forEachNode) {
            tableApi.forEachNode((n) => {
                if (node) return;
                if (String(n?.data?.id) === String(row.id)
                    && String(n?.data?.orderId ?? '') === String(row.orderId ?? '')) {
                    node = n;
                }
            });
        }
        const live = node?.data?.id ? node.data : row;
        setAll(false);
        setDrawerSingleData([live]);
        setOpenDrawer(true);
        if (node) {
            tableApi?.ensureNodeVisible(node, 'top');
        }
    }, [setAll, setOpenDrawer, setDrawerSingleData]);

    const orderSignature = (orderId: string | number | undefined, refId?: string) =>
        `${orderId ?? ''}_${refId ?? ''}`;

    const orderIdNum = (id: unknown) => {
        const n = Number(id);
        return Number.isFinite(n) ? n : -1;
    };

    const resolveNewOrderRow = React.useCallback((
        rowData: OrderData,
        oData: any[] | undefined,
        existingOrderSignatures: Set<string>,
    ) => {
        const existingOrderIds = new Set(
            [...existingOrderSignatures].map((sig) => String(sig).split('_')[0]).filter((id) => id !== ''),
        );
        // The save response lists every order for the client that day. Column sort does not
        // change that array, so the first match is often the older order. Take the newest id
        // that was not already on the grid.
        const candidates = (oData ?? []).filter(
            (d) => d.type === 'order'
                && d.status !== 'canceled'
                && String(d.entId) === String(rowData.id)
                && d.id != null
                && String(d.id) !== ''
                && String(d.id) !== '0'
                && !existingOrderIds.has(String(d.id)),
        );
        const newDoc = candidates.reduce((best, d) => (
            !best || orderIdNum(d.id) >= orderIdNum(best.id) ? d : best
        ), undefined as any);
        if (!newDoc) {
            const newRows = tempDataRef.current.filter(
                (d) => String(d.id) === String(rowData.id)
                    && String(d.orderId ?? '') !== ''
                    && !existingOrderIds.has(String(d.orderId)),
            );
            if (newRows.length === 0) return null;
            return newRows.reduce((best, d) => (
                orderIdNum(d.orderId) >= orderIdNum(best.orderId) ? d : best
            ));
        }

        let row = tempDataRef.current.find(
            (d) => String(d.id) === String(rowData.id)
                && String(d.orderId) === String(newDoc.id),
        );
        if (!row || existingOrderIds.has(String(row.orderId ?? ''))) {
            row = clearCopiedForcedDetails(createOrderDataEasy(rowData, String(newDoc.id)));
            writeOrdersToOD(row, newDoc);
            row = {
                ...row,
                id: String(rowData.id ?? newDoc.entId ?? ''),
                customer: row.customer || rowData.customer || newDoc.entName || '',
                orderId: String(newDoc.id),
                ref_id: newDoc.ref_id ?? '',
            };
        }
        if (!row?.id || existingOrderIds.has(String(row.orderId ?? ''))) return null;
        return row;
    }, []);

    const handlePickCustomerOrder = React.useCallback(async (newValue: OrderData, tableApi?: any) => {
        const hasOrder = Boolean(newValue?.orderId && String(newValue.orderId).length > 0)
            || (newValue?.dvs?.length ?? 0) > 0;

        if (!hasOrder) {
            openDrawerForOrderRow(newValue, tableApi);
            return;
        }

        const result = await Swal.fire({
            title: `ללקוח ${newValue.customer} קיימת הזמנה`,
            text: 'מה תרצה לעשות?',
            icon: 'question',
            showCancelButton: true,
            showDenyButton: true,
            confirmButtonText: 'ערוך הזמנה קיימת',
            denyButtonText: 'צור הזמנה נוספת',
            cancelButtonText: 'ביטול',
            showClass: {
                popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
                popup: 'animate__animated animate__fadeOutUp',
            },
        });

        if (result.isConfirmed) {
            openDrawerForOrderRow(newValue, tableApi);
        } else if (result.isDenied) {
            const existingOrderSignatures = new Set(
                tempDataRef.current
                    .filter((d) => String(d.id) === String(newValue.id))
                    .map((d) => orderSignature(d.orderId, d.ref_id)),
            );
            const oData = await newClientOrder([newValue]);
            let newRow = resolveNewOrderRow(newValue, oData, existingOrderSignatures);
            if (!newRow) {
                await new Promise((r) => setTimeout(r, 350));
                newRow = resolveNewOrderRow(newValue, oData, existingOrderSignatures);
            }
            if (newRow) {
                openDrawerForOrderRow(newRow, tableApi);
            }
        }
    }, [newClientOrder, openDrawerForOrderRow, resolveNewOrderRow]);

    const addDataAction = useMemo(() => {
        return {
            tooltip: "הוסף הזמנה חדשה",
            label: "חפש הזמנה או לקוח",
            component(tableApi) {
                return (
                    <Autocomplete
                        id='pick-customer'
                        options={tempData}
                        getOptionLabel={(option: any) => `מזהה ${externalIdSearch ? option.externalId : option.id} ${option?.customer}  ${option?.orderId}`}
                        autoHighlight
                        onChange={(event, newValue) => {
                            if (newValue) {
                                handlePickCustomerOrder(newValue, tableApi);
                            }
                        }}
                        sx={{width: 150, marginTop: "-5px", marginRight: "5px"}}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label='הוסף הזמנה'
                                variant='outlined'
                                size='small'
                            />
                        )}
                    />
                )
            },
        }
    }, [tempData, externalIdSearch, handlePickCustomerOrder]);


    const activeCellTimeoutRef = React.useRef<NodeJS.Timeout | null>(null);
    const handleOnActiveCellChange = React.useCallback((params) => {
        if (!openStatistics) return;

        const node = params?.api?.getDisplayedRowAtIndex(params?.rowIndex);
        const pId = params?.column?.colDef?.id.startsWith("p_") ? params?.column?.colDef?.id.split("_")[1] : undefined;
        if (node?.data) {
            if (activeCellTimeoutRef.current)
                clearTimeout(activeCellTimeoutRef.current);
            activeCellTimeoutRef.current = setTimeout(() => {
                setActiveRow(node?.data);
                if(pId)
                setActiveP(Number(pId));
                else
                setActiveP(null);
            }, 200);
        } else {
            setActiveRow(undefined);
            setActiveP(null);
        }
    }, [openStatistics]);

    // Build a fast lookup map from orderKey to index to avoid O(n) scans on each edit
    const tempIndexRef = React.useRef<Map<string, number>>(new Map());
    useEffect(() => {
        const m = new Map<string, number>();
        try {
            tempData?.forEach?.((item: any, idx: number) => {
                m.set(orderKey(item), idx);
            });
        } catch (_) {
            // noop
        }
        tempIndexRef.current = m;
    }, [tempData]);

    // tempIndexRef is a stable ref object. We read tempIndexRef.current at execution time,
    // so it does not need to be in the dependency array. Including it would not change memoization.
    // We intentionally keep dependencies minimal to avoid re-creating the callback on every data change.
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    const editCallbackMany = useCallback(async (params) => {
        // Group incoming edits by order key
        const grp = groupByUnStr(params, (p) => orderKey(p?.data));


        setTempData((prev: any[]) => {
            if (!prev || prev.length === 0) return prev;
            // Start with a shallow copy; we'll only replace truly changed items
            const next = prev.slice();


            Object.keys(grp).forEach((key) => {
                const arr = grp[key];
                if (!arr || arr.length === 0) return;

                // Resolve index using ref map; fallback to linear search if missing
                let idx = tempIndexRef.current.get(key);
                if (idx === undefined) {
                    idx = prev.findIndex((d: any) => orderKey(d) === key);
                    if (idx === -1) return; // not found, skip
                }

                // Base new row on existing row data to preserve fields
                const base = prev[idx];
                const newD: any = { ...base };
                newD.me = newD;

                let been = false;

                arr.forEach((p: any) => {
                    if (p?.newValue != p?.oldValue) {
                        newD.hasBeenEdited=true
                        been = true;
                        updatedRowIds.add(orderKey(p?.node?.data));
                        updatedDriverRowIds.add(p?.node?.data?.id);
                        const field = p?.column?.colDef?.field;
                        if (field) newD[field] = p?.newValue;

                        // סדר נהגים edited while the order has a נהג זמני, an already forced position,
                        // or is closed (readonly after delivery/invoice): store on the order
                        // (OrderNote.force_position), keeping the client daily position aside untouched.
                        if (field === 'driver_position' && (hasTempOrderDriver(newD) || newD.force_position_on || newD.readonly)) {
                            if (!newD.force_position_on) {
                                newD.daily_position = p?.oldValue;
                                newD.force_position_on = true;
                            }
                        }
                        // Temp driver removed: drop the forced position and fall back to the daily position.
                        // Keep orderDriver as undefined (not '') so the נהג column stays editable.
                        if (field === 'orderDriver' && (p?.newValue == undefined || p?.newValue == '')) {
                            newD.orderDriver = undefined;
                            if (newD.force_position_on) {
                                newD.force_position_on = false;
                                if (newD.daily_position != undefined) newD.driver_position = newD.daily_position;
                            }
                        }

                        if (JSDB().userCofcConf?.conversion_rate_blocker == 1 || JSDB().userCofcConf?.conversion_rate_blocker == 2) {
                            if (field?.includes('p_')) {
                                const id = field.split('_')[1];
                                if (
                                    JSDB().getClientProduct(Number(id)).first?.getOrderProduct()?.extraUnitOn() == true &&
                                    newD[`u_${id}`] == undefined
                                ) {
                                    newD[`u_${id}`] = 1;
                                }
                            }
                        }
                    }
                });

                if (been) {
                    next[idx] = newD;
                }
            });

            return next;
        });
    }, [updatedRowIds, updatedDriverRowIds]);

    const tableDividers = JSON.parse(localStorage.getItem('orders-table-dividers') || '[]');
    const tableControls: ITableControls = {
        tableName: 'customers/order-list',
        sidebar: true,
        localisation: true,
        fixH: true,
        manyEditTime:100,
        chipDisplayAmount: 7,
        disableDefaultEditActions: true,
        savedColFilter:["p","_p","p_","_p_","rrp","_rrp","rrp_","_rrp_"],
        canonicalColumnOrder: canonicalProductColumnOrder,
        groupBy: {
            enable: true,
            rowGroup: true,
            pivot: true,
            value: true,
            allowSave: true,
        },
        drag: {
            enable: true,
            complex: true,
            multiRow: true,
            customeDragEndAction(params) {
                const overNode = params?.overNode;
                const overNodeDriverPosition = overNode?.data?.driver_position;
                const newStartPosition = overNodeDriverPosition - params?.nodes?.length > 0 ? overNodeDriverPosition - params?.nodes?.length : 0;
                // Map orderKey → new position so we only touch the dragged rows, not every
                // sibling order sharing the same client id (which would copy notes/products across).
                const draggedPositions = new Map<string, number>();
                params?.nodes?.forEach((n, i) => {
                    const key = orderKey(n?.data);
                    draggedPositions.set(key, newStartPosition + i + 1);
                    updatedRowIds.add(key);
                    updatedDriverRowIds.add(n?.data?.id);
                });
                setTempData((prev) =>
                    prev.map((d) => {
                        const newDriverPosition = draggedPositions.get(orderKey(d));
                        if (newDriverPosition === undefined) return d;
                        const newD = {...d};
                        // Reorder while a נהג זמני / forced position is on, or the order is closed:
                        // keep the change on the order (force_position) and leave the client daily untouched.
                        if ((hasTempOrderDriver(newD) || newD.force_position_on || newD.readonly) && !newD.force_position_on) {
                            newD.daily_position = newD.driver_position;
                            newD.force_position_on = true;
                        }
                        newD.driver_position = newDriverPosition;
                        newD.me = newD;
                        return newD;
                    })
                );
                setReorderDrivers(true);
            },
        },
        selection: {
            enable: true,
            mode: "multiple"
        },
        extractId: (row) => orderKey(row?.data),
        cellRenderer: (params, column, i) => {

            if (column.cellRenderer) {
                const rendered = column.cellRenderer({
                    params,
                    column,
                    i,
                    setOpenCustomerDrawer,
                    setSelectedCustomerId,
                    updatedRowIds,
                    setTempData,
                    setPreviewOpen
                });
                if (rendered !== undefined) {
                    return rendered;
                }
            }

            if (typeof params?.value === "object") {
                const value = params?.value?.value || "";
                return value;
            }
            return params?.value || '';
        },
        excelPrependTop: (col) => {
            if (col?.includes('p_')) {
                const id = col?.split('_')[1]
                return JSDB().getClientProduct(Number(id)).first?.getOrderProduct()?.englishName || ''
            }
        },
        rowStyle: (params) => {
            let style: any = {'borderLeft': `1px solid ${theme.palette.divider}`};
            if (params?.node?.rowPinned) return {};

            if (params?.node?.data?.status == "סופק ללקוח")
                style = {...style, backgroundColor: '#638fff'}
            else if (params?.node?.data?.readonly && (params?.node?.data?.all_dvs_printed || notesArePrinted(params?.node?.data?.dvs)))
                style = {...style, backgroundColor: '#9ffd9f'}
            else if (params?.node?.data?.readonly)
                style = {...style, backgroundColor: '#adffe1'}
            else if (params?.node?.data?.syncConflict)
                style = {...style, backgroundColor: '#ffb347', cursor: 'pointer'}
            else if (params?.node?.data?.status == "בוצעה")
                style = {...style, backgroundColor: '#cda7e8'}
            else if (params?.node?.data?.status == "לוקט")
                style = {...style, backgroundColor: '#ffa563'}

            else if (color_surface && params?.columnApi?.getColumn('mName')?.visible && params?.node?.data?.mName % 2 !== 0) {
                style = {
                    ...style,
                    'background-color': "#808080a6",
                }
            }

            if (params.node?.rowIndex > 0 && params?.columnApi?.getColumn('driverName')?.sort) {
                const previousNode = params.api.getDisplayedRowAtIndex(params.node.rowIndex - 1);
                if (previousNode && previousNode?.data?.driverName !== params?.node?.data?.driverName) {
                    style = {...style, 'border-top': 'solid 5px black'}
                }

            }
            if (tableDividers?.includes(params?.column?.colDef?.field)) {
                style = {
                    ...style,
                    'border-right': `1.5px solid black`,
                }
            }


            return style
        },
        floatingFilters: false,
        replaceContextMenu: true,
        disableEditableCellStyle: true,
        sideBarActions: [],
    }

    const pinnedControl = useMemo(() => {
        const onlyfirst = {}
        const onlysecond = {}
        const onlythird = {}
        const fInventory = {}
        const totalInventory = {}
        const afterInv = {}
        if (showProducts) {
            products.forEach((p) => {
                fInventory[`p_${p?.id}`] = (d) => 0

                totalInventory[`p_${p?.id}`] = (d) => (0)
                const conversion_rate = JSDB().getClientProduct(Number(p.id)).first?.getOrderProduct()?.conversion_rate ?? 0
                onlysecond[`p_${p?.id}`] = (d) => {
                    const v = (d?.[`p_${p?.id}`] ?? 0)
                    const u = (d?.[`u_${p?.id}`] ?? 0)
                    // third unit (u==2) is order-only with no conversion: excluded from sums
                    if (u == 2) {
                        return 0
                    } else if (v && u) {
                        return v
                    } else if (v && conversion_rate) {
                        return v / conversion_rate
                    }

                    return 0
                }
            })

            products.forEach((p) => {
                const extra = JSDB().getClientProduct(Number(p.id)).first?.getOrderProduct()?.extraUnitOn()
                const conversion_rate = JSDB().getClientProduct(Number(p.id)).first?.getOrderProduct()?.conversion_rate ?? 0
                onlyfirst[`p_${p?.id}`] = (d) => {
                    const v = (d?.[`p_${p?.id}`] ?? 0)
                    const u = (d?.[`u_${p?.id}`] ?? 0)
                    // third unit (u==2) is order-only with no conversion: excluded from sums
                    if (u == 2) {
                        return 0
                    } else if (v && !u) {
                        return v
                    } else if (v && u && conversion_rate) {
                        return v * conversion_rate
                    }
                    return 0
                }
            })

            // order-only third unit (no conversion, never charged): its own summary row,
            // mirroring onlyfirst/onlysecond above.
            products.forEach((p) => {
                onlythird[`p_${p?.id}`] = (d) => {
                    const v = (d?.[`p_${p?.id}`] ?? 0)
                    const u = (d?.[`u_${p?.id}`] ?? 0)
                    return u == 2 ? v : 0
                }
            });

            const inventoryRows = Array.isArray(fullInventory) ? fullInventory : [];
            inventoryRows.forEach((p) => {
                fInventory[`p_${p?.id}`] = (d) => (p.totalInventory ?? 0)
                const x = Number(pinnedInventoryEditable[`p_${p?.id}`])
                const x2= Number(pinnedInventoryEditable2[`p_${p?.id}`])

                totalInventory[`p_${p?.id}`] = (d) => ((p.totalInventory ?? 0) + (x && !isNaN(x) ? x : 0)) + (x2 && !isNaN(x2) ? x2 : 0)
            })
            fInventory.customer = (d) => 'מלאי מחסן'
            totalInventory.customer = (d) => 'מלאי מחסן + חדש'
            afterInv.customer = (d) => 'מלאי ישן + חדש'
            products.forEach((p) => {
                const x = Number(pinnedInventoryEditable[`p_${p?.id}`])
                const y = Number(pinnedOldInventoryEditable[`p_${p?.id}`])
                const x2 = Number(pinnedInventoryEditable2[`p_${p?.id}`])

                afterInv[`p_${p?.id}`] = (d) => (y && !isNaN(y) ? y : 0) + (x && !isNaN(x) ? x : 0) + (x2 && !isNaN(x2) ? x2 : 0)
            })
        }

        return {
            pinnedRowControlsNew: [{
                id: 1,
                label: "סיכום הזמנות",
                func: {
                    customer: (d) => 'סיכום הזמנות',
                }
            },
                {
                    id: 5,
                    label: "סיכום כמות מרכזית",
                    func: {
                        customer: (d) => 'סיכום כמות מרכזית',
                    },
                    valueGetter: onlyfirst
                },
                {
                    id: 6,
                    label: "סיכום כמות משנית",
                    func: {
                        customer: (d) => 'סיכום כמות משנית',
                    },
                    valueGetter: onlysecond
                },
                {
                    id: 10,
                    label: "סיכום כמות שלישית",
                    func: {
                        customer: (d) => 'סיכום כמות שלישית',
                    },
                    valueGetter: onlythird
                },
                {
                    id: 11,
                    label: "מלאי ישן",

                    editableData: pinnedOldInventoryEditable,
                    editable: (params) => {
                        setPinnedOldInventoryEditable(prevState => {
                            const x = {
                                ...prevState,


                            }
                            x.hasBeenEdited = true;
                            x[`${params?.colDef?.field}`] = params?.value
                            x[`edit_${params?.colDef?.field}`] = true
                            return x
                        })

                        return false
                    }
                },
                {
                    id: 12,
                    label: "מלאי ישן+חדש",
                    func: afterInv
                },
                {
                    id: 2,
                    label: "מלאי חדש",

                    editableData: pinnedInventoryEditable,
                    editable: (params) => {

                        setPinnedInventoryEditable(prevState => {
                            const x = {
                                ...prevState,


                            }
                            x.hasBeenEdited = true;
                            x[`${params?.colDef?.field}`] = params?.value
                            x[`edit_${params?.colDef?.field}`] = true
                            return x
                        })

                        return false
                    }
                },
                {
                    id: 4,
                    label: "מלאי חדש 2",

                    editableData: pinnedInventoryEditable2,
                    editable: (params) => {

                        setPinnedInventoryEditable2(prevState => {
                            const x = {
                                ...prevState,


                            }
                            x.hasBeenEdited = true;
                            x[`${params?.colDef?.field}`] = params?.value
                            x[`edit_${params?.colDef?.field}`] = true
                            return x
                        })

                        return false
                    }
                },

                {
                    id: 3,
                    label: "לאחר חלוקה",

                    sumByConfigurations: {
                        func: 'minus',
                        name: 'customer',
                        ids: [12, 1]
                    }

                },

                {
                    id: 7,
                    label: "מלאי מחסן",
                    func: fInventory
                },
                {
                    id: 8,
                    label: "מלאי מחסן + חדש",
                    func: totalInventory
                },
                {
                    id: 9,
                    label: "חיסור מלאי סופי",

                    sumByConfigurations: {
                        func: 'minus',
                        name: 'customer',
                        ids: [8, 1]
                    }
                },
            ],
            pinnedRowTopDefault: [1],
            pinnedRowBotDefault: [],
            control: true,


        }
    }, [pinnedInventoryEditable, pinnedOldInventoryEditable,pinnedInventoryEditable2, products, showProducts, fullInventory])
    const [openSelectProductsToExport, setOpenSelectProductsToExport] = React.useState(undefined);
    const [issueFromOrder, setIssueFromOrder] = React.useState<{
        customerId: string;
        type: 'invoice' | 'delivery_certificate';
        products: any[];
        refId: number[];
        date?: Date;
    } | undefined>(undefined);
    const [externalAnchor, setExternalAnchor] = React.useState(undefined);
    const [selectedForDuplicate, setSelectedForDuplicate] = React.useState([]);
    const [clientTransferAction, setClientTransferAction] = React.useState<{docs: any[], action: 'copy' | 'move'} | undefined>(undefined);
    const [transferTargetClient, setTransferTargetClient] = React.useState<any>(null);

    const menuScopeRef = React.useRef({date, toDate, activeState});
    menuScopeRef.current = {date, toDate, activeState};
    const extentedContextMenu = React.useCallback((params) => {
        if (params) {
            const scope = menuScopeRef.current;
            return contextMenu2(params, setTempData, removeAllFilters, onApplyFilter, addCustomerFilter, scope.activeState, dvs_flag, updatedRowIds, saveOrder, cancelDV, scope.date, theme, deleteOrder, updatedDriverRowIds, setSingleDelete, setSelectedCustomersSend, setDistributeDialogOn, setReorderDialog, newClientOrder, setDocumentAction, setOpenSelectProductsToExport, setSelectedForDuplicate, setExternalAnchor,pinnedControl,cols, setClientTransferAction, setDriverLinkRows, setPersistentDriverLinkRows, aiAssistant.routeAssignEnabled, setIssueFromOrder, scope.toDate) as any;
        }
        return []
    }, [dvs_flag, updatedRowIds, updatedDriverRowIds, theme, saveOrder, cancelDV, deleteOrder, removeAllFilters, onApplyFilter, addCustomerFilter, setTempData, setSingleDelete, newClientOrder,pinnedControl,cols, aiAssistant.routeAssignEnabled]);
    return (
        <>
            <DataSheetGridContext.Provider
                value={React.useMemo(() => ({
                    activeRow,
                    openDrawer,
                    setOpenDrawer,
                    handleOpenDrawer,
                    setSingleDelete,
                    setDrawerSingleData,
                    callPrevOrder,
                    cancelDV,
                    updatedRowIds,
                    updatedDriverRowIds,
                    date,
                    disableKeyBoard: setDisableKeyBoard,
                    saveOrder,
                    callPrevDaily,
                    deleteOrder,
                    dvs_flag,
                    activeState,
                    onApplyFilter,
                    addCustomerFilter,
                    removeAllFilters,
                    setAll,
                    setActiveRow,
                    onOpenSyncConflict,
                }), [activeRow, openDrawer, updatedRowIds, updatedDriverRowIds, date, dvs_flag, activeState,
                    setOpenDrawer, handleOpenDrawer, setSingleDelete, setDrawerSingleData, callPrevOrder,
                    cancelDV, setDisableKeyBoard, saveOrder, callPrevDaily, deleteOrder, onApplyFilter,
                    addCustomerFilter, removeAllFilters, setAll, setActiveRow, onOpenSyncConflict])} disableKeyBoard
            >
                <AgTable
                    columns={cols}
                    data={showData}
                    outSideTableRef={tableRef}
                    tableControls={tableControls}
                    refreshCells={refreshRowIds}
                    menuiItems={menuItems}
                    addDataAction={addDataAction}
                    extentedContextMenu={extentedContextMenu}
                    clearEditFromAbove={clearEditFromAbove}
                    chipDetails={chipDetails}
                    saveDataCallback={saveDataCallback}
                    customeCancelEdit={() => restoreAllChanges()}
                    editCallbackMany={editCallbackMany}
                    pinnedControl={pinnedControl}
                    onCellFocused={handleOnActiveCellChange}
                    onColumnMoveCallback={onColumnMoveCallback}
                    filterQ={true}
                    onCellClick={(params) => {
                        const row = params?.data;
                        if (!row?.syncConflict || params?.rowPinned) return;
                        const field = String(params?.colDef?.field || params?.colDef?.id || '');
                        if (/^(p_|price_|u_|np_|discount_|use_price_|lock_|n_|sn_|hp_|hu_)/.test(field)) return;
                        onOpenSyncConflict?.(row);
                    }}
                />
            </DataSheetGridContext.Provider>
            {openCustomerDrawer ? <AddCustomer
                open={openCustomerDrawer}
                handleDrawerOpen={() => setOpenCustomerDrawer(false)}
                id={selectedCustomerId?.id}
                editable={true}
                updateCallBack={() => {

                    refreshClientData()
                    setSelectedCustomerId(undefined)
                }}
            /> : undefined}

            {openStatistics?.open ?
                <ChipRangeDate open={openStatistics} setOpen={(o) => setOpenStatistics(
                    (p) => ({...p, open: o})
                )} filterFunc={(range) => {
                    setOpenStatistics((p) => {
                        return {
                            open: false,
                            fromDate: range[0],
                            toDate: range[1],
                            name: 'orders-customer-statistics'
                        }

                    })
                }
                }/> : undefined
            }
            {openCustomeRangePicker ?
                <ChipRangeDate open={openCustomeRangePicker} setOpen={setOpenCustomeRangePicker}
                               filterFunc={callClientVisit}/> : undefined
            }
            {distributeDialogOn ?
                <FormDialog
                    distributeDialogOn={distributeDialogOn}
                    setData={setTempData}
                    updatedRowIds={updatedRowIds}
                    setDistributeDialogOn={setDistributeDialogOn}
                    setRefreshRowIds={setRefreshRowIds}
                /> : undefined
            }
            {
                reorderDialog ? (
                    <ReorderDialogOrders reorderDialog={reorderDialog} setReorderDialog={setReorderDialog}
                                         setData={setTempData}
                                         updatedRowIds={updatedRowIds}
                                         updatedDriverRowIds={updatedDriverRowIds}
                                         setRefreshRowIds={setRefreshRowIds}/>

                ) : null
            }
            {driverLinkRows && (
                <DriverLinkDialog
                    open={true}
                    rows={driverLinkRows}
                    onClose={() => setDriverLinkRows(undefined)}
                />
            )}
            {persistentDriverLinkRows && (
                <PersistentDriverLinkDialog
                    open={true}
                    rows={persistentDriverLinkRows}
                    onClose={() => setPersistentDriverLinkRows(undefined)}
                />
            )}
            {/* שלח לינק וכו׳: onSend מעדכן סטטוס (ממתין ללקוח). בוואטסאפ החדש אותו onSend נקשר אוטומטית אחרי שליחה מוצלחת דרך hooks/useWhatsAppSendLifecycle (אפשר useWhatsAppSendComplete ללוגיקה גלובלית נוספת). */}
            {selectedCustomersSend != undefined ? <SendMessageDialog
                open={selectedCustomersSend != undefined}
                setOpen={(open) => setSelectedCustomersSend(undefined)}

                toSelected={selectedCustomersSend?.selected ?? []}
                files={selectedCustomersSend?.files ?? []}
                msg={selectedCustomersSend?.msg ?? ""}
                subject={selectedCustomersSend?.subject ?? ""}
                defaultPlatform={selectedCustomersSend?.defaultPlatform ?? "email"}
                withFiles={false}
                action_date={selectedCustomersSend?.action_date ?? date}
                onSend={selectedCustomersSend?.onSend}
                externalVar={selectedCustomersSend?.externalVar ?? []}
            /> : undefined}
            {clientTransferAction && (
                <Dialog
                    open={true}
                    onClose={() => { setClientTransferAction(undefined); setTransferTargetClient(null); }}
                    maxWidth="sm"
                    fullWidth
                >
                    <Box sx={{ p: 3 }}>
                        <Typography variant="h4" sx={{ mb: 2 }}>
                            {clientTransferAction.action === 'copy' ? 'העתק ללקוח אחר' : 'העבר ללקוח אחר'}
                        </Typography>
                        <Autocomplete
                            options={tempData
                                .filter((d) => d.id && d.id !== '' && !clientTransferAction.docs.some((s) => s.id === d.id))
                                .map((d) => ({ id: d.id, label: d.customer || '' }))
                                .filter((v, i, arr) => arr.findIndex((x) => x.id === v.id) === i)}
                            getOptionLabel={(option) => option.label || ''}
                            onChange={(_, newValue) => setTransferTargetClient(newValue)}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            renderInput={(params) => <TextField {...params} label="בחר לקוח יעד" />}
                        />
                        <Box sx={{ mt: 2, display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                            <MenuItem
                                onClick={() => { setClientTransferAction(undefined); setTransferTargetClient(null); }}
                                sx={{ border: 1, borderColor: 'divider', borderRadius: 1 }}
                            >
                                ביטול
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    if (transferTargetClient) {
                                        transferClientOrder(clientTransferAction.docs, transferTargetClient.id, clientTransferAction.action);
                                        setClientTransferAction(undefined);
                                        setTransferTargetClient(null);
                                    }
                                }}
                                disabled={!transferTargetClient}
                                sx={{ bgcolor: clientTransferAction.action === 'copy' ? 'primary.main' : 'error.main', color: 'white', borderRadius: 1 }}
                            >
                                {clientTransferAction.action === 'copy' ? 'העתק' : 'העבר'}
                            </MenuItem>
                        </Box>
                    </Box>
                </Dialog>
            )}
            {documentAction ? <ChooseDateMultiAction title={documentAction.title} info={documentAction.docs}
                                                     setDocumentAction={setDocumentAction} func={(date,activeState) => {
                let toDate = date
                if(activeState && activeState.day!=-1){
                    let day=4+activeState.day-1
                    toDate = new Date(`2010-01-0${day}`)
                }
                if(documentAction!.doc_type=="order_inventory"){
                    console.log("yotam")
                    inventoryDup.mutate({toDate: toDate, pd: documentAction.docs});
                }

                else {
                    const moving = documentAction.action !== "duplicate";
                    const closedWithDv = moving
                        ? (documentAction.docs || []).filter((d) => isClosedOrderWithDeliveryNote(d))
                        : [];
                    const openDocs = moving
                        ? (documentAction.docs || []).filter((d) => d?.orderId && !isClosedOrderWithDeliveryNote(d))
                        : documentAction.docs;
                    if (closedWithDv.length > 0) {
                        const canMoveOpen = openDocs.length > 0;
                        const allDocs = documentAction.docs;
                        Swal.fire({
                            title: closedOrderWithDeliveryWarning.title,
                            text: closedWithDv.length === 1
                                ? `${closedOrderWithDeliveryWarning.text} אפשר להעביר בכל זאת.`
                                : `יש ${closedWithDv.length} הזמנות סגורות עם תעודת משלוח. אפשר להעביר אותן בכל זאת.`,
                            icon: 'warning',
                            showCancelButton: true,
                            showDenyButton: canMoveOpen,
                            confirmButtonText: canMoveOpen ? 'העבר רק הזמנות פתוחות' : 'העבר בכל זאת',
                            denyButtonText: 'העבר בכל זאת',
                            cancelButtonText: 'ביטול',
                        }).then((result) => {
                            if (result.isDenied || (result.isConfirmed && !canMoveOpen)) {
                                openOrders.mutate({date: toDate, docs: allDocs, dup: false});
                            } else if (result.isConfirmed && canMoveOpen) {
                                openOrders.mutate({date: toDate, docs: openDocs, dup: false});
                            }
                        });
                    } else {
                        openOrders.mutate({date: toDate, docs: documentAction.docs, dup: documentAction.action === "duplicate"});
                    }
                }
                setDocumentAction(undefined)
            }}/> : undefined}

            {
                openSelectProductsToExport ? <ProductsToExportDialog
                    open={openSelectProductsToExport != undefined}
                    setOpen={() => setOpenSelectProductsToExport(undefined)}
                    selectedCustomers={openSelectProductsToExport.selectedCustomers}
                    date={date}
                    detailed={openSelectProductsToExport.detailed}
                    byDelivery={openSelectProductsToExport.byDelivery}
                /> : undefined
            }
            {externalAnchor ? <BaseOrDataSelector disabled={selectedForDuplicate?.some((d: any) => d?.readonly)}
                                                  callPrevDaily={callPrevDaily}
                                                  callPrevOrder={callPrevOrder}
                                                  ids={selectedForDuplicate.map((d: any) => d.id)}
                                                  date={date}
                                                  externalAnchor={externalAnchor}
            /> : undefined}

            {issueFromOrder ? <Dialog
                fullWidth
                maxWidth="lg"
                open
                disableEscapeKeyDown
                onBackdropClick={() => setIssueFromOrder(undefined)}
                sx={{'& .MuiDialog-paper': {p: 0}}}
            >
                <Box sx={{px: 2, pt: 2}}>
                    <Typography variant="body2" color="text.secondary">
                        {TYPED_FIRST_UNIT_MESSAGE} אחר כך הנפק
                        {issueFromOrder.type === 'invoice' ? ' חשבונית' : ' תעודת משלוח'}.
                    </Typography>
                </Box>
                <DocumentNew
                    customerId={issueFromOrder.customerId}
                    type={issueFromOrder.type}
                    productsFromAbove={issueFromOrder.products}
                    refId={issueFromOrder.refId}
                    initialDocumentDate={issueFromOrder.date ?? date}
                    markFromOrder
                />
            </Dialog> : undefined}
            {previewOpen && (!(previewOpen?.length && previewOpen?.length> 1)  || previewOpen?.length==1) ? <Dialog fullWidth open={previewOpen} maxWidth="lg"  onBackdropClick={() => {
                setPreviewOpen(undefined);

            }}
                                   sx={{'& .MuiDialog-paper': {p: 0}}}>
                <DocumentPreview setSelectedCustomersSend={setSelectedCustomersSend} document={previewOpen?.length==1 ? previewOpen[0]:previewOpen}
                                 collect={true} onCanceled={applyCanceledDocument}/>
            </Dialog> : undefined}
            {
                previewOpen && previewOpen?.length && previewOpen?.length> 1
                    ?
                    <Dialog fullWidth
                            maxWidth='lg'
                            scroll='body' open={true} onBackdropClick={() => {
                        setPreviewOpen(undefined);
                    }}
                            sx={{ '& .MuiDialog-paper': { p: 0 } }}>
                        <Collapse in={true} timeout='auto' unmountOnExit>
                            <Box sx={{ margin: 1 }}>
                                <Typography variant='h4' gutterBottom component='div'>
                                    פירוט עבור נהג
                                </Typography>
                                <TableContainer sx={{ maxHeight: 700 }}>
                                    <DocumentsTable data={previewOpen} setSelectedCustomersSendF={setSelectedCustomersSend} onDocumentCanceled={applyCanceledDocument} />

                                </TableContainer>
                            </Box>
                        </Collapse>
                    </Dialog>
                    : undefined
            }
        </>
    );
};

export default memo(OrdersDataSheet2);
